import React, { Component } from "react";
import { formatChapterName } from '../../../utils/formatChapterName';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import { cityActionId, countryActionId, countryIWithCodeActionId, exhibitorBadgeDaysActionId, pincodeActionId, visitorTypeListActionId, stateActionId, toastError, GSTvalidationActionId, visitPurposeActionId, seminarInterestActionId, companyTurnOverActionId, exhibitionStatusActionId, toastSuccess, industryChaptersActionId, genderActionId, AccountTypeActionId, primaryChapterListActionId, B2BTimeslotActionID, visitorInterestActionId, BASE_URL } from "../../../utils/constants";
import { ToggleButton, Dropdown, Form } from "react-bootstrap";
import { fill_action } from "../../../actions/fillCombo_action"
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import moment from "moment";
import { getExhNoteDetails_action } from "../../../actions/admin_module_action/master_action/exhibition_master_action/exh_note_action"
import DatePicker from "react-datepicker";
import { verifyVisitorEmail_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getDelegateCombineDetails_action, delegateRegistrationCombineSubmit_action, getDelegateFirldList_action } from "../../../actions/delegate_module_action/delegate_form_action/delegate_form_action"
import Resizer from "react-image-file-resizer";
import { combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action } from "../../../actions/visitor_module_action/visitor_form_action/visitor_form_action"
import { emailValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import { getVisitorRegistrationCredentials_action, getCoordinatorVisitor_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { payment_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getDelegatePreviewDetails_action, deleteVisaDoc_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { getExhibitionProgramMaster_action } from "../../../actions/admin_module_action/delegate_master_action/delegate_program_action"

class DelegateForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            DelegateRegistrationID: '',
            modalID: '',
            isDelegateSelect: false,
            AccountTypeID: '',
            AccountTypeName: '',
            AccountID: '',
            DelegateRegistrationNo: '',
            DelegateRegistrationIDModal: '',
            AccountTypeIDModal: '',
            AccountIDModal: '',
            DelegateRegistrationNoModal: '',
            mainB2bArr: [],
            isVisaUpdated: false,

            isExhbitionClosed: false,
            isDataLoad: false,
            isOtherPreName: false,
            otherName: 'Mr',
            firstName: '',
            firstNameErr: '',
            prename: '',
            lastName: '',
            lastNameErr: '',
            countryIdErr: '',
            countryId: '',
            countryList: [],
            genderErr: '',
            preMobNo: '',
            preWhatsAppMobNo: '',
            stateList: [],
            tempStateList: [],
            cityList: [],
            tempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            genderList: [],
            gender: '',
            designation: '',
            designationErr: '',
            institute: '',
            instituteErr: '',
            IECCode: '',
            IECCodeErr: '',
            Address1: '',
            Address2: '',
            Address3: '',
            Address1Err: '',
            dueDate: '',
            pincode: '',
            isDisplayPincodeList: false,
            pincodeErr: '',
            regState: '',
            regStateErr: '',
            isDisplayStateList: false,
            city: '',
            cityErr: '',
            isDisplayCityList: false,
            email: '',
            emailErr: '',
            mobNo: '',
            mobNoErr: '',
            whatsAppMobNo: '',
            whatsAppMobNoErr: '',
            isSameAsMobNo: false,
            website: '',
            telNo: '',
            preTelNo: '',
            tel1No: '',
            preTel1No: '',
            compInfoGstNo: '',
            compInfoGstNoErr: '',
            stateName: '',
            stateId: '',
            compInfoPanNoErr: '',
            compInfoPanNo: '',
            gstValidtionList: [],
            chapterList: [],
            visitorTypeList: [],
            visitorTypeErr: '',
            VisitorTypeID: '',
            chapterErr: '',
            other: '',
            isOtherOpen: false,
            visitPurposeErr: '',
            visitPurposeList: [],
            IsIntrestedForB2B: false,
            interestList: [],
            isInterestTwo: false,
            isInterstOne: false,
            daysList: [],
            isExhibitionFree: false,
            arrivalDate: '',
            arrivalDateErr: '',
            departureDate: '',
            departureDateErr: '',
            isCoordinator: false,
            isCoordinatorAsDelegate: false,
            companyProfile: '',
            companywebsite: '',
            totalYears: '',
            PersonProfile: '',
            PersonPhoto: "",
            PersonPhotoData: '',
            PersonPhotoName: '',
            PersonPhotoType: "",
            PersonPhotoPreview: '',
            PersonPhotoErr: '',
            PersonProfileErr: '',
            turnOverList: [],
            turnOverId: '',
            turnOverErr: '',
            totalYearsErr: '',
            companyProfileErr: '',
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            ChapterHallErr: '',
            B2bMeetingList: [],
            b2bErr: '',
            needVisaAssistance: false,
            passName: '',
            passNameErr: '',
            applicantMobNo: '',
            applicantMobNoErr: '',
            preApplicantMobNo: '',
            applicantEmail: '',
            applicantEmailErr: '',
            passNo: '',
            passNoErr: '',
            passDate: '',
            passDateErr: '',
            passExipryDate: '',
            passExipryDateErr: '',
            passCountryErr: '',
            passCountry: '',
            isPassportFilePresent: false,
            isVisaApplied: false,
            passportFileErr: '',
            passportFile: '',
            passPortFileName: '',
            passportFilePath: '',
            passportFileType: '',
            Source: '',
            SeminarErr: '',
            selectedVisitorID: '',
            delegateList: [],
            seminarInterestList: [],
            interestListModal: [],
            isInterestTwoModal: false,
            isInterstOneModal: false,
            daysListModal: [],
            isModalEdit: false,
            GroupDetailsList: [],
            isOtherPreNameModal: false,
            otherNameModal: 'Mr',
            firstNameModal: '',
            firstNameErrModal: '',
            prenameModal: '',
            lastNameModal: '',
            lastNameErrModal: '',
            countryIdErrModal: '',
            countryIdModal: '',
            countryListModal: [],
            genderErrModal: '',
            preMobNoModal: '',
            preWhatsAppMobNoModal: '',
            stateListModal: [],
            tempStateListModal: [],
            cityListModal: [],
            tempCityListModal: [],
            pincodeListModal: [],
            tempPincodeListModal: [],
            seminarInterestListModal: [],
            genderListModal: [],
            genderModal: '',
            designationModal: '',
            designationErrModal: '',
            instituteModal: '',
            instituteErrModal: '',
            IECCodeModal: '',
            IECCodeErrModal: '',
            Address1Modal: '',
            Address2Modal: '',
            Address3Modal: '',
            Address1ErrModal: '',
            pincodeModal: '',
            isDisplayPincodeListModal: false,
            pincodeErrModal: '',
            regStateModal: '',
            regStateErrModal: '',
            isDisplayStateListModal: false,
            cityModal: '',
            cityErrModal: '',
            isDisplayCityListModal: false,
            emailModal: '',
            emailErrModal: '',
            mobNoModal: '',
            mobNoErrModal: '',
            whatsAppMobNoModal: '',
            whatsAppMobNoErrModal: '',
            isSameAsMobNoModal: false,
            websiteModal: '',
            telNoModal: '',
            preTelNoModal: '',
            tel1NoModal: '',
            preTel1NoModal: '',
            compInfoGstNoModal: '',
            compInfoGstNoErrModal: '',
            stateIdModal: '',
            stateNameModal: '',
            compInfoPanNoErrModal: '',
            visitPurposeErrModal: '',
            compInfoPanNoModal: '',
            chapterErrModal: '',
            chapterListModal: [],
            isOtherOpenModal: false,
            otherModal: '',
            seminarInterestListModal: [],
            companyProfileModal: '',
            companywebsiteModal: '',
            totalYearsModal: '',
            PersonProfileModal: '',
            PersonPhotoModal: "",
            PersonPhotoDataModal: '',
            PersonPhotoNameModal: '',
            PersonPhotoTypeModal: "",
            PersonPhotoPreviewModal: '',
            PersonPhotoModalErr: '',
            PersonProfileModalErr: '',
            turnOverListModal: [],
            visitPurposeListModal: [],
            turnOverIdModal: '',
            turnOverErrModal: '',
            totalYearsErrModal: '',
            companyProfileErrModal: '',
            isFirst: true,
            arrivalDateModal: '',
            arrivalDateErrModal: '',
            departureDateModal: '',
            departureDateErrModal: '',
            daysErr: '',
            daysErrModal: '',
            ChapterHallErrModal: '',
            primaryChapterListDataModal: [],
            level0Modal: [],
            level2Modal: [],
            level3Modal: [],
            level4Modal: [],
            primaryChapterListLevel3Modal: [],
            primaryChapterListLevel4Modal: [],
            B2bMeetingListmodal: [],
            b2bErrModal: '',
            SeminarErrModal: '',
            needVisaAssistanceModal: false,
            passNameModal: '',
            passNameErrModal: '',
            applicantMobNoModal: '',
            applicantMobNoErrModal: '',
            preApplicantMobNoModal: '',
            applicantEmailModal: '',
            applicantEmailErrModal: '',
            passNoModal: '',
            passNoErrModal: '',
            passDateModal: '',
            passDateErrModal: '',
            passExipryDateModal: '',
            passExipryDateErrModal: '',
            passCountryErrModal: '',
            passCountryModal: '',
            isPassportFilePresentModal: false,
            isVisaAppliedModal: false,
            passportFileErrModal: '',
            passportFileModal: '',
            passPortFileNameModal: '',
            passportFilePathModal: '',
            passportFileTypeModal: '',

            tempGroupPincodeList: [],
            tempGroupCityList: [],
            tempGroupStateList: [],

            accountTypeList: [],
            AccountTypeIDErr: '',
            agreeTerms: false,
            note: [],
            CoordinatorID: '',
            isLinkOpen: false,
            showFieldList: [],

            coordinatorVisitorRegistrationID: '',

            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownStateModal: false,
            focusedIndexStateModal: -1,

            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            isOpenDropDownCityModal: false,
            focusedIndexCityModal: -1,

            isOpenDropDownPin: false,
            focusedIndexPin: -1,
            isOpenDropDownPinModal: false,
            focusedIndexPinModal: -1,

            Address2Err: '',
            Address3Err: '',
            websiteErr: '',
            telephoneErr: '',
            telephone1Err: '',
            companyWebsiteErr: '',
            visaErr: '',
            isB2bMeetingShow: false,
            programList: [],
            isfromAdmin: false,
        }
        this.submitfrm = React.createRef()
        this.getFillList = this.getFillList.bind(this)
        this.onSelectDates = this.onSelectDates.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onSelectPrimaryChapter = this.onSelectPrimaryChapter.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onSelectPurpose = this.onSelectPurpose.bind(this)
        this.getDelegateCredentials = this.getDelegateCredentials.bind(this)
        this.getDrawerDetails = this.getDrawerDetails.bind(this)
        this.otherDetailsChange = this.otherDetailsChange.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.recordTwo = this.recordTwo.bind(this)
        this.onDelegateSelect = this.onDelegateSelect.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordThree = this.recordThree.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.getRegistrationDetails = this.getRegistrationDetails.bind(this)
        this.getCoordinatorVisitor = this.getCoordinatorVisitor.bind(this)
        this.onCountrySelect = this.onCountrySelect.bind(this)
        this.callStateList = this.callStateList.bind(this)
        this.verifyEmail = this.verifyEmail.bind(this)
        this.onGSTchange = this.onGSTchange.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.getCoordinatorDelegate = this.getCoordinatorDelegate.bind(this)
        this.getNotes = this.getNotes.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.getFieldList = this.getFieldList.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.showMandatoryFields = this.showMandatoryFields.bind(this)

    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data == null) {
                        // request failed (axiosGet returns null) - keep the chain moving
                        resolve(false)
                        return
                    }
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1) {
                        // ExhibitionID
                        if (actionID === primaryChapterListActionId) {
                            console.log("primaryChapterListActionId 121212", data.data)
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr?.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        // console.log(arr[i].ChapterName)
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName?.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }

                            for (var i = 0; i < data.data['primaryChapter']?.length; i++) {
                                if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                    data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                }
                                if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                    data.data['primaryChapter'].splice(i, 1)
                                }
                                console.log(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level2']?.length; i++) {
                                for (var j = 0; j < data.data['level2']?.length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            console.log(data.data['primaryChapter'])
                            for (var i = 0; i < data.data['primaryChapter']?.length; i++) {
                                for (var j = 0; j < data.data['primaryChapter']?.length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level3']?.length; i++) {
                                for (var j = 0; j < data.data['level3']?.length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2']?.length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4']?.length; i++) {
                                for (var j = 0; j < data.data['level4']?.length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3']?.length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2']?.length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }
                            for (var i = 0; i < data.data['level2']?.length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            const level0list = data.data['level0'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const primaryChapterListDatalist = data.data['primaryChapter'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level2list = data.data['level2'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level3list = data.data['level3'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level4list = data.data['level4'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],
                                primaryChapterListDataModal: primaryChapterListDatalist ? primaryChapterListDatalist : [],
                                level0Modal: level0list ? level0list : [],
                                level2Modal: level2list ? level2list : [],
                                level3Modal: level3list ? level3list : [],
                                level4Modal: level4list ? level4list : [],

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === countryIWithCodeActionId) {
                            console.log("country data", data.data[0]['ExhibitionID'])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail?.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile?.split(",") : []
                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                            sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])

                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                            sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                            sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])

                            sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                            this.setState({
                                isDataLoad: true,
                                bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner']
                            })

                            // this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')
                            resolve(true)
                        }
                        if (actionID === exhibitionStatusActionId) {
                            console.log("exhibitionStatusActionId", data.data)
                            this.setState({
                                isExhbitionClosed: data != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                            })
                            sessionStorage.setItem("ExhCode", data.data[0]['Code'])
                            resolve(true)
                        }
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data != null ? data.data : [],
                                personalCountryList: data.data,
                                tempPersonalCountryList: data.data,
                                delgationCountryList: data.data,
                                tempDelegationCountryList: data.data,
                                passCountryList: data.data,
                                tempPassCountryList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                tempGroupStateList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === companyTurnOverActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                turnOverList: data.data,
                                turnOverListModal: data.data,
                            })
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                tempGroupCityList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === seminarInterestActionId) {
                            data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            list.sort((a, b) => a.SeqNo - b.SeqNo);
                            list?.length > 0 && list.map((item) => {
                                if (item.ParentSeminarID != null) {
                                    item.Day = ''
                                }
                            })
                            const result = this.calculateRowspan(list);
                            this.setState({
                                seminarInterestList: result,
                                seminarInterestListModal: listModal,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                tempGroupPincodeList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === genderActionId) {
                            console.log("genderActionId data", data.data)
                            this.setState({
                                genderList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === GSTvalidationActionId) {
                            console.log("country data", data.data)
                            this.setState({ gstValidtionList: data.data })
                            resolve(true)
                        }
                        if (actionID === industryChaptersActionId) {
                            console.log("industryChaptersActionId 121212", data.data)
                            // var list = []
                            // var listModal = []
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            this.setState({
                                chapterList: list,
                                chapterListModal: listModal,

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === visitorTypeListActionId) {
                            console.log("Attendee Type data", data.data)

                            data.data?.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({ visitorTypeList: data.data })
                            resolve(true)
                        }
                        if (actionID === visitPurposeActionId) {
                            console.log(" Visit Purpose List data", data.data)
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherDetails: ""
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherDetails: ""
                            }));
                            this.setState({
                                visitPurposeList: list,
                                visitPurposeListModal: listModal,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === visitorInterestActionId) {
                            this.setState({
                                interestList: data.data,
                                interestListModal: data.data,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === exhibitorBadgeDaysActionId) {
                            console.log("exhibitor data", data.data)
                            var DateList = []
                            // var DateListModal = []
                            // data.data.map(item => {
                            //     DateList.push(item)
                            // })
                            // data.data.map(item => {
                            //     DateListModal.push(item)
                            // })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                DateList.push(mapData)
                                // DateListModal.push(mapData)
                            })
                            const DateListModal = DateList.map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            this.setState({
                                daysList: DateList,
                                daysListModal: DateListModal,
                                isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            resolve(true)
                        }
                        if (actionID === B2BTimeslotActionID) {
                            // console.log(" Visit Purpose List data", data.data)
                            var B2bDates = []
                            this.setState({ mainB2bArr: data.data })
                            var tempData = data.data.map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            tempData.sort((a, b) => {
                                const dateA = new Date(a.B2BDate);
                                const dateB = new Date(b.B2BDate);

                                // First compare by B2BDate
                                if (dateA < dateB) return -1;
                                if (dateA > dateB) return 1;

                                // If B2BDate is the same, compare by B2BStartTime
                                if (a.B2BStartTime < b.B2BStartTime) return -1;
                                if (a.B2BStartTime > b.B2BStartTime) return 1;

                                return 0;
                            });
                            const uniqueDAta = tempData.filter((value, index, self) => {
                                // Create a unique identifier using both name and no
                                const identifier = `${value.B2BDate}-${value.B2BLocation}`;

                                // Check if this combination has appeared before
                                return index === self.findIndex((t) => `${t.B2BDate}-${t.B2BLocation}` === identifier);
                            });

                            const keysToKeep = ['B2BDate', 'B2BLocation'];

                            // Remove keys from each object
                            const modifiedArray = uniqueDAta.map(obj => {
                                // Create a new object that only includes the keys you want to keep
                                return Object.keys(obj).reduce((newObj, key) => {
                                    if (keysToKeep.includes(key)) {
                                        newObj[key] = obj[key];
                                    }
                                    return newObj;
                                }, {});
                            });

                            modifiedArray?.length > 0 && modifiedArray.map((item) => {
                                var obj = {}
                                obj.date = item
                                // objModal.date = item
                                obj.timeSlotList = []
                                data.data?.length > 0 && data.data.map((item2) => {
                                    if (item.B2BDate == item2.B2BDate && item.B2BLocation == item2.B2BLocation) {
                                        var timeobj = {}
                                        timeobj.timeslot = `${item2.B2BStartTime} To ${item2.B2BEndTime}`
                                        timeobj.IsBooked = item2.IsBooked
                                        timeobj.isSelect = false
                                        timeobj.B2BTimeSlotID = item2.B2BTimeSlotID
                                        obj.timeSlotList.push(timeobj)
                                        // objModal = { ...obj }
                                    }
                                })

                                // finalDateList.push(obj)
                                item.timeSlotList = obj.timeSlotList
                                // item.rowSpan = obj.timeSlotList?.length
                                // finalDateListModal.push(objModal)
                            })

                            data.data?.length > 0 && data.data.map((item) => {
                                if (!B2bDates.includes(item.B2BDate)) {
                                    B2bDates.push(item.B2BDate)
                                }
                            })
                            B2bDates.map(item => {
                                var dateCount = 0
                                modifiedArray.map(obj => {
                                    if (item == obj.B2BDate) {
                                        dateCount++
                                        obj.rowSpan = 0
                                    }
                                })
                                for (var i = 0; i < modifiedArray?.length; i++) {
                                    if (item == modifiedArray[i].B2BDate) {
                                        modifiedArray[i].rowSpan = dateCount
                                        break
                                    }
                                }
                            })
                            const modifiedArrayModal = modifiedArray.map(item => ({
                                ...item, // Copy the item object
                                timeSlotList: item.timeSlotList.map(subItem => ({ ...subItem })) // Deep clone the list inside each item
                            }));

                            // this.setState({ items2: items2Clone });


                            // const finalDateListModal = finalDateList.map(item => ({
                            //     ...item // Create a new object for the modal list
                            // }));
                            // data.data?.length > 0 && data.data.map((item) => {
                            //     item.isSelect = false
                            //     item.otherDetail = ""
                            // })
                            // console.log(finalDateListModal, 'finalDateList', finalDateList)
                            this.setState({
                                B2bMeetingList: modifiedArray,
                                B2bMeetingListmodal: modifiedArrayModal,
                            }, () => {
                                setTimeout(() => {
                                    console.log('tempData', this.state.B2bMeetingList, modifiedArray)

                                }, 500);
                            })
                            // // if (!isPrevious) {
                            // //     this.setState({ isLoading: false, })
                            // // }
                            resolve(modifiedArray)
                        }

                        if (actionID === AccountTypeActionId) {
                            this.setState({
                                accountTypeList: data.data,
                                // interestListModal: data.data,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                    }
                })
        })
    }

    handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate size
        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        // Validate file type
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
            PersonPhoto: '',
            PersonPhotoPreview: image,
            PersonPhotoName: file.name,
            PersonPhotoType: fileExtension,
            PersonPhotoData: image.split(',')[1], // remove base64 prefix
            PersonPhotoErr: ''
        });
    };

    clearFileInput = () => {
        this.setState({
            PersonPhoto: null,
            PersonPhotoPreview: '',
            PersonPhotoName: '',
            PersonPhotoData: '',
            PersonPhotoType: '',
        });
    };
    handleImageUploadModal = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate size
        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        // Validate file type
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
            PersonPhotoModal: '',
            PersonPhotoPreviewModal: image,
            PersonPhotoNameModal: file.name,
            PersonPhotoTypeModal: fileExtension,
            PersonPhotoDataModal: image.split(',')[1], // remove base64 prefix
            PersonPhotoModalErr: ''
        });
    };

    clearFileInputModal = () => {
        this.setState({
            PersonPhotoModal: null,
            PersonPhotoPreviewModal: '',
            PersonPhotoNameModal: '',
            PersonPhotoDataModal: '',
            PersonPhotoTypeModal: '',
        });
    };
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 500, 600, "JPEG", 80, 0,
                (uri) => { resolve(uri); },
                "base64", 300, 300);
        });
    calculateRowspan(data) {
        const parentChildMap = {};
        data.forEach(item => {
            item.Rowspan = 0;
            if (item.ParentSeminarID !== null) {
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });
        return data;
    }


    getExhibitionProgramMaster(exhCode) {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            console.log(exhCode, 'chapterIDArr')
            this.props
                .getExhibitionProgramMaster_action(exhCode)
                .then((data) => {
                    console.log(exhCode, 'chapterIDArr2')
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        const [programs, dates, categories] = data.data;
                        programs.map((program, index) => {
                            var temppath = program.InvitationCard
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            program.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            // data.data[0][0].DocumentType = ''
                            // data.data[0][0].DocumentFile = ''
                            program.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            // setTimeout(() => {

                        })
                        setTimeout(() => {
                            const result = dates.map((date, index) => {
                                const program = programs.find(
                                    program => program.ExhProgramID === date.ExhProgramID
                                );

                                const firstIndex = dates.findIndex(
                                    item => item.ExhProgramID === date.ExhProgramID
                                );

                                const rowspan = dates.filter(
                                    item => item.ExhProgramID === date.ExhProgramID
                                ).length;

                                const dateCategories = categories
                                    .filter(
                                        category =>
                                            category.ExhProgramDateID === date.ExhProgramDateID
                                    )
                                    .map(category => ({
                                        ...category,
                                        isSelect: false
                                    }));
                                console.log(program, 'programprogram')
                                return {
                                    ExhProgramID: program.ExhProgramID,
                                    ExhibitionID: program.ExhibitionID,
                                    ProgramName: program.ProgramName,
                                    Location: program.Location,
                                    IsActive: program.IsActive,
                                    DocumentName: program.DocumentName,
                                    DocumentPath: program.DocumentPath,
                                    isSelect: false,
                                    toShow: index === firstIndex,
                                    rowspan,

                                    ExhProgramDateID: date.ExhProgramDateID,

                                    // Date → 17/08/2026
                                    Date: moment(date.Date).format("DD/MM/YYYY"),

                                    Days: date.Days,

                                    // Time → 10:00
                                    StartTime: moment(date.StartTime).format("HH:mm"),
                                    EndTime: moment(date.EndTime).format("HH:mm"),

                                    catogary: dateCategories
                                };
                            });

                            console.log('resultresultresult', result)
                            this.setState({ programList: result });
                        }, 100);

                        resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    window.location.reload()
                    console.log(e);
                });
        })
    }

    componentDidMount() {
        console.log(this.props.location.state, 'selectedVisitorID')
        this.setState({
            dueDate: sessionStorage.getItem("VisaApprovalLastDate") != null && sessionStorage.getItem("VisaApprovalLastDate") != '' ? new Date(JSON.parse(sessionStorage.getItem("VisaApprovalLastDate"))) : null,
            isLoading: true
        })
        sessionStorage.removeItem("SelectedDelegateDataSS")
        if (this.props.location?.state) {
            this.setState({ selectedVisitorID: this.props.location?.state?.selectedVisitorID, isfromAdmin: this.props.location.state.update })
        }
        console.log('this.props.location.state', this.props.location.state)
        if (sessionStorage.getItem('sessionExhibitionID')) {

            console.log(sessionStorage.getItem('sessionExhibitionID'), 'sessionStorage.getItem()')
            this.getExhibitionProgramMaster(sessionStorage.getItem('sessionExhibitionID'))
        }
        // if (sessionStorage.getItem('SelectedDelegateDataSS') != null) {
        //     this.setState({ selectedVisitorID: JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).AccountID })
        // }
        this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

            this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                this.getFillList(AccountTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                    this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                            this.getFillList(B2BTimeslotActionID, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                this.getFillList(countryIWithCodeActionId, '', '', '', sessionStorage.getItem('ExhCode'), '').then(() => {
                                    this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                        this.getFillList(genderActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                            this.getDrawerDetails()
                                            this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', 3, '', '').then(() => {
                                                this.getFillList(companyTurnOverActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                    this.getFillList(visitPurposeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                        this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                            this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                    this.getDelegateCredentials(0, this.props.location.state?.selectedVisitorID).then(() => {
                                                                        setTimeout(() => {
                                                                            this.getRegistrationDetails(this.props.location.state?.selectedVisitorID)
                                                                            this.getNotes()
                                                                        }, 500);
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }).catch(() => {
                this.setState({ isLoading: false })
            })
        }).catch(() => {
            this.setState({ isLoading: false })
        })
    }

    getCoordinatorDelegate(coordinatorVisitorRegistrationID, selectedVisitorID) {
        return new Promise((() => {
            this.props.getCoordinatorDelegate_action(coordinatorVisitorRegistrationID ? coordinatorVisitorRegistrationID : this.state.coordinatorVisitorRegistrationID, selectedVisitorID)
                .then((data) => {
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1) {
                        data.data.map(item => {
                            if (item.AccountID == this.state.CoordinatorID) {
                                this.setState({ selectedVisitorID: item.AccountID })
                            }
                        })
                        this.setState({ delegateList: data.data })
                    }
                    else {
                        toastError(data.msg)
                    }
                }).catch((err) => { console.log(err) })
        }))
    }

    getRegistrationDetails(selectedVisitorID) {
        const { primaryChapterListData, programList, level2, level3, level4, seminarInterestList, isDelegateSelect, chapterList, visitPurposeList, daysList, B2bMeetingList } = this.state
        this.setState({ isLoading: true })
        this.props.getDelegateCombineDetails_action(isDelegateSelect == true ? true : false, selectedVisitorID)
            .then((data) => {
                if (data == null) {
                    this.setState({ isLoading: false })
                    toastError('Something went wrong. Please try again.')
                    return
                }
                if (data.error != 1) {
                    daysList?.length > 0 && daysList.map((element) => {
                        element.isSelect = false
                    })
                    chapterList?.length > 0 && chapterList.map((element) => {
                        element.isSelect = false
                    })
                    visitPurposeList?.length > 0 && visitPurposeList.map((element) => {
                        element.isSelect = false
                    })
                    primaryChapterListData?.length > 0 && primaryChapterListData.map((element) => {
                        element.isSelect = false
                    })
                    level2?.length > 0 && level2.map((element) => {
                        element.isSelect = false
                    })
                    level3?.length > 0 && level3.map((element) => {
                        element.isSelect = false
                    })
                    level4?.length > 0 && level4.map((element) => {
                        element.isSelect = false
                    })
                    seminarInterestList?.length > 0 && seminarInterestList.map((element) => {
                        element.isSelect = false
                    })
                    B2bMeetingList?.length > 0 && B2bMeetingList.map((element) => {
                        element.isShow = true
                        element.timeSlotList?.length > 0 && element.timeSlotList.map((inElement) => {
                            inElement.isSelect = false
                        })
                    })

                    var mob1 = data.data?.[0]?.[0]?.['MobileNo']
                    const parts = mob1?.split("-");
                    const Mob1Code = parts?.length == 2 ? parts?.[0] : ''
                    const Mob1No = parts?.length == 2 ? parts?.[1] : mob1
                    var mob2 = data.data?.[0]?.[0]?.['WhatsappMobileNo']
                    const parts2 = mob2?.split("-")
                    const Mob2Code = parts2?.length == 2 ? parts2?.[0] : ''
                    const Mob2No = parts2?.length == 2 ? parts2?.[1] : mob2
                    var mob5 = data.data?.[0]?.[0]?.['ApplicantMobileNo']
                    const parts5 = mob5?.split("-")
                    const Mob5Code = parts5?.length == 2 ? parts5?.[0] : ''
                    const Mob5No = parts5?.length == 2 ? parts5?.[1] : mob5
                    var tel = data.data?.[0]?.[0]?.['Telephone']
                    const parts3 = tel?.split("-")
                    const telCode = parts3?.length == 2 ? parts3?.[0] : ''
                    const telNumber = parts3?.length == 2 ? parts3?.[1] : tel
                    var tel1 = data.data?.[0]?.[0]?.['Telephone1']
                    const parts4 = tel1?.split("-")
                    const tel1Code = parts4?.length == 2 ? parts4?.[0] : ''
                    const tel1Number = parts4?.length == 2 ? parts4?.[1] : tel1
                    console.log("daysListdaysListdaysList", daysList)
                    var selectedDaysList = data.data?.[1] != null ? data.data?.[1] : []
                    daysList?.length > 0 && daysList.map((element) => {
                        selectedDaysList?.length > 0 && selectedDaysList.map((element2) => {
                            if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                element.isSelect = true
                            }
                        })
                    })
                    var selectedChapters = data.data?.[2] != null ? data.data?.[2] : []
                    chapterList?.length > 0 && chapterList.map((element) => {
                        selectedChapters?.length > 0 && selectedChapters.map((element2) => {
                            if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                element.isSelect = true
                            }
                        })
                    })
                    var selectedPurposeOfVisit = data.data?.[4] != null ? data.data?.[4] : []
                    visitPurposeList?.length > 0 && visitPurposeList.map((element) => {
                        selectedPurposeOfVisit?.length > 0 && selectedPurposeOfVisit.map((element2) => {
                            if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                element.isSelect = true
                            }
                            console.log(element2.OtherNames)
                            if (element2.OtherNames != '') {
                                element.OtherDetails = element2.OtherNames
                            }
                        })
                    })

                    var SelectedHallChapters = data.data?.[3] != null ? data.data?.[3] : []
                    primaryChapterListData?.length > 0 && primaryChapterListData.map((element) => {
                        SelectedHallChapters?.length > 0 && SelectedHallChapters.map((element2) => {
                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                            }
                        })
                    })
                    level2?.length > 0 && level2.map((element) => {
                        SelectedHallChapters?.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                            }
                        })
                    })
                    level3?.length > 0 && level3.map((element) => {
                        SelectedHallChapters?.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                            }
                        })
                    })
                    level4?.length > 0 && level4.map((element) => {
                        SelectedHallChapters?.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                            }
                        })
                    })

                    var selectedseminarList = data.data?.[5] != null ? data.data?.[5] : []
                    console.log(selectedseminarList, 'selectedDaysList', seminarInterestList)

                    seminarInterestList?.length > 0 && seminarInterestList.map((element) => {
                        selectedseminarList?.length > 0 && selectedseminarList.map((element2) => {
                            if (element2.SeminarID == element.SeminarID) {
                                element.isSelect = true
                            }
                        })
                    })
                    const selectedB2bList = data.data?.[6] != null ? data.data?.[6] : []
                    if (sessionStorage.getItem("RoleIDSS") == 15) {
                        if (selectedB2bList.length > 0) {
                            this.setState({ isB2bMeetingShow: true })
                        }
                    } else {
                        this.setState({ isB2bMeetingShow: true })
                    }
                    const temparr = [...B2bMeetingList]
                    B2bMeetingList?.length > 0 && B2bMeetingList.map((element) => {
                        element.timeSlotList?.length > 0 && element.timeSlotList.map((inElement) => {
                            selectedB2bList?.length > 0 && selectedB2bList.map((element2) => {
                                if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                    inElement.isSelect = true
                                    inElement.IsBooked = false
                                    element.isShow = true
                                }
                            })
                        })
                    })

                    this.getFillList(pincodeActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                    this.getFillList(stateActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                    this.getFillList(cityActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                    var filePath = data.data?.[0]?.[0]?.PassportFilePath != null ? data.data?.[0]?.[0]?.['PassportFilePath'] : ''
                    var array = data.data?.[0]?.[0]?.['PassportFilePath'] != null && data.data?.[0]?.[0]?.['PassportFilePath'] != "" && filePath?.split("/")
                    const FileName = array[array?.length - 1]
                    if (programList.length > 0) {
                        var ExhProgramArr = []
                        var ExhProgramDateArr = []
                        var ExhProgramCategoryArr = []
                        programList.map(main => {
                            data.data[11].map(item => {
                                if (main.ExhProgramDateID == item.ExhProgramDateID) {
                                    main.isSelect = true
                                }
                            })
                            main.catogary.map(main2 => {
                                data.data[12].map(item => {
                                    if (main2.ExhProgramCategoryID == item.ExhProgramCategoryID) {
                                        main2.isSelect = true
                                    }
                                })
                            })
                        })
                    }
                    setTimeout(() => {
                        // Fall back to the selected country's ISD code when the saved number has no code
                        const savedCountry = this.state.countryList?.find(obj => obj.Code == data.data?.[0]?.[0]?.CountryID)
                        const defaultIsd = savedCountry?.CountryCode ? `+${savedCountry.CountryCode}` : ''
                        this.setState({
                            DelegateRegistrationID: data.data?.[0]?.[0]?.DelegateRegistrationID ?? '',
                            AccountTypeID: data.data?.[0]?.[0]?.AccountTypeID ?? '',
                            AccountTypeName: data.data?.[0]?.[0]?.AccountTypeName?.split(' ')[0] ?? '',
                            AccountID: data.data?.[0]?.[0]?.AccountID ?? '',
                            DelegateRegistrationNo: data.data?.[0]?.[0]?.DelegateRegistrationNo ?? '',
                            isOtherPreName: data.data[0][0].PersonIncharge_Title != 'Mr' && data.data[0][0].PersonIncharge_Title != 'Ms' && data.data[0][0].PersonIncharge_Title != 'DR' && data.data[0][0].PersonIncharge_Title != 'Prof' ? true : false,
                            otherName: data.data[0][0].PersonIncharge_Title != 'Mr' && data.data[0][0].PersonIncharge_Title != 'Ms' && data.data[0][0].PersonIncharge_Title != 'DR' && data.data[0][0].PersonIncharge_Title != 'Prof' ? data.data[0][0].PersonIncharge_Title : '',
                            prename: data.data[0][0].PersonIncharge_Title != 'Mr' && data.data[0][0].PersonIncharge_Title != 'Ms' && data.data[0][0].PersonIncharge_Title != 'DR' && data.data[0][0].PersonIncharge_Title != 'Prof' ? 'Other' : data.data[0][0].PersonIncharge_Title,
                            firstName: data.data?.[0]?.[0]?.PersonIncharge_FirstName ?? '',
                            lastName: data.data?.[0]?.[0]?.PersonIncharge_LastName ?? '',
                            gender: data.data?.[0]?.[0]?.PersonIncharge_GenderID ?? '',
                            designation: data.data?.[0]?.[0]?.PersonIncharge_Designation ?? '',
                            institute: data.data?.[0]?.[0]?.CompanyName ?? '',
                            compInfoGstNo: data.data?.[0]?.[0]?.GSTNo ?? '',
                            compInfoPanNo: data.data?.[0]?.[0]?.PanNo ?? '',
                            IECCode: data.data?.[0]?.[0]?.IECCode ?? '',
                            Address1: data.data?.[0]?.[0]?.Address1 ?? '',
                            Source: data.data?.[0]?.[0]?.Source ?? '',
                            Address2: data.data?.[0]?.[0]?.Address2 ?? '',
                            Address3: data.data?.[0]?.[0]?.Address3 ?? '',
                            city: data.data?.[0]?.[0]?.City ?? '',
                            regState: data.data?.[0]?.[0]?.State ?? '',
                            pincode: data.data?.[0]?.[0]?.Pin ?? '',
                            email: data.data?.[0]?.[0]?.PrimaryEmail ?? '',
                            website: data.data?.[0]?.[0]?.Website ?? '',
                            preTelNo: telCode,
                            telNo: telNumber,
                            preTel1No: tel1Code,
                            tel1No: tel1Number,
                            countryId: data.data?.[0]?.[0]?.CountryID ?? '',
                            CountryName: data.data?.[0]?.[0]?.CountryNmae ?? '',
                            preMobNo: Mob1Code || defaultIsd,
                            mobNo: Mob1No,
                            preWhatsAppMobNo: Mob2Code || defaultIsd,
                            whatsAppMobNo: Mob2No,
                            companyProfile: data.data?.[0]?.[0]?.CompanyProfile ?? '',
                            companywebsite: data.data?.[0]?.[0]?.CompanyWebsite ?? '',
                            totalYears: data.data?.[0]?.[0]?.TotalOperationalYears ?? '',
                            turnOverId: data.data?.[0]?.[0]?.CompanyTurnOverID ?? '',
                            arrivalDate: new Date(data.data?.[0]?.[0]?.ArrivalDate) ?? '',
                            departureDate: new Date(data.data?.[0]?.[0]?.DepartureDate) ?? '',
                            // isCoordinator: data.data?.[0]?.[0]?.IsCoordinator ?? '',
                            isCoordinatorAsDelegate: data.data?.[0]?.[0]?.isCoordinatorAsDelegate ?? '',
                            isSameAsMobNo: data.data?.[0]?.[0]?.IsSameMobileNo ?? '',
                            PersonProfile: data.data?.[0]?.[0]?.PersonProfile ?? '',
                            PersonPhoto: data.data?.[0]?.[0]?.PersonPhoto ?? '',
                            chaptersList: chapterList,
                            seminarInterestList: seminarInterestList,
                            daysList: daysList,
                            visitPurposeList: visitPurposeList,
                            level2: level2,
                            level3: level3,
                            level4: level4,
                            primaryChapterListData: primaryChapterListData,
                            isInterestTwo: data.data?.[0]?.[0]?.IsIntrestedForB2B ?? '',
                            IsIntrestedForB2B: data.data?.[0]?.[0]?.IsIntrestedForB2B ?? '',
                            applicantEmail: data.data?.[0]?.[0]?.ApplicantEmailID ?? '',
                            preApplicantMobNo: Mob5Code || defaultIsd,
                            applicantMobNo: Mob5No,
                            passName: data.data?.[0]?.[0]?.NameOnPassport ?? '',
                            passExipryDate: data.data?.[0]?.[0]?.PassportExpiryDate != '' && data.data?.[0]?.[0]?.PassportExpiryDate != null ? new Date(data.data?.[0]?.[0]?.PassportExpiryDate) : '',
                            passportFile: FileName ?? '',
                            passPortFileName: FileName ?? '',
                            passportFilePath: data.data?.[0]?.[0]?.PassportFilePath ?? '',
                            passportFileType: '',
                            passDate: data.data?.[0]?.[0]?.PassportIssueDate != '' && data.data?.[0]?.[0]?.PassportIssueDate != null ? new Date(data.data?.[0]?.[0]?.PassportIssueDate) : '',
                            passCountry: data.data?.[0]?.[0]?.PassportIssuingCountryID ?? '',
                            passNo: data.data?.[0]?.[0]?.PassportNo ?? '',
                            needVisaAssistance: data.data?.[0]?.[0]?.isVisaAssistance ?? '',
                            isSameAsMobNo: data.data?.[0]?.[0]?.IsSameMobileNo ?? '',
                            isPassportFilePresent: data.data?.[0]?.[0]?.PassportFilePath != null && data.data?.[0]?.[0]?.PassportFilePath != '' ? true : false,
                            isVisaApplied: data.data?.[0]?.[0]?.PassportFilePath != null && data.data?.[0]?.[0]?.PassportFilePath != '' ? true : false,
                            agreeTerms: data.data?.[0]?.[0]?.IsAgree,
                            isLoading: false
                        }, () => {
                            if (data.data?.[0]?.[0]?.CountryID == 91) {
                                this.getFillList(pincodeActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                                this.getFillList(stateActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                                this.getFillList(cityActionId, '', '', data.data?.[0]?.[0]?.CountryID, '', '')
                                setTimeout(() => {

                                    this.setState({
                                        isOpenDropDownState: false,
                                        focusedIndexState: -1,
                                        isOpenDropDownStateModal: false,
                                        focusedIndexStateModal: -1,

                                        isOpenDropDownCity: false,
                                        focusedIndexCity: -1,
                                        isOpenDropDownCityModal: false,
                                        focusedIndexCityModal: -1,

                                        isOpenDropDownPin: false,
                                        focusedIndexPin: -1,
                                        isOpenDropDownPinModal: false,
                                        focusedIndexPinModal: -1,
                                    })
                                }, 100);
                            }
                        })
                    }, 500);
                    setTimeout(() => {
                        this.getFieldList(data.data?.[0]?.[0]?.AccountTypeID)
                    }, 200);
                }
            })
    }

    getDrawerDetails() {
        this.props.getDrawerDetails_action()
            .then((data) => {
                if (data == null) {
                    this.setState({ isLoading: false })
                    toastError('Something went wrong. Please try again.')
                    return
                }
                if (data.error != 1) {
                    sessionStorage.setItem("sessionVisitorDrawerData", JSON.stringify(data.data))
                    var address = data.data[0] != null && data.data[0] != "" && data.data[0]['Address'] != null && data.data[0]['Address'] != "" &&
                        data.data[0]['Address']
                    var addArray = address != "" && address != null && address?.split(",")
                    sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray))

                    var mobNo = data.data[0] != null && data.data[0] != "" && data.data[0]['MobileNo'] != null && data.data[0]['MobileNo'] != "" &&
                        data.data[0]['MobileNo']
                    var MobArray = mobNo != "" && mobNo != null && mobNo?.split(",")
                    sessionStorage.setItem("FormatedMobNo", JSON.stringify(MobArray))
                }
                else {
                    toastError(data.msg)
                }
            }).catch((err) => { console.log(err) })
    }

    onCountrySelect(e, status) {
        const { countryList } = this.state
        var countryId = e.target.value
        if (countryId != '') {
            if (status == 1) {
                this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNoModal: `+${countryCode}`,
                    preWhatsAppMobNoModal: `+${countryCode}`,
                    preApplicantMobNoModal: `+${countryCode}`
                })
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            } else if (status == 2) {
                this.setState({ passCountry: countryId, passCountryErr: "" })
            } else if (status == 3) { this.setState({ passCountryModal: countryId, passCountryErrModal: "" }) } else {
                this.setState({ countryId: countryId, countryIdErr: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNo: `+${countryCode}`,
                    preWhatsAppMobNo: `+${countryCode}`,
                    preApplicantMobNo: `+${countryCode}`
                })
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            }
            setTimeout(() => {
                this.setState({
                    isDisplayPincodeList: false,
                    isDisplayCityList: false,
                    isDisplayStateList: false,
                    isDisplayPincodeListModal: false,
                    isDisplayCityListModal: false,
                    isDisplayStateListModal: false,
                    isVisaUpdated: true
                })
            }, 200);
        }
    }

    onPincodeSearch(e, status) {
        const { pincodeList, tempPincodeList, tempGroupPincodeList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchPincodeList = tempGroupPincodeList.filter(data => {
                    return (data.Pincode.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    pincodeModal: e.target.value,
                    pincodeErrModal: "",
                    tempGroupPincodeList: searchPincodeList,
                    isDisplayPincodeListModal: true
                })
            } else {
                this.setState({
                    pincodeModal: e.target.value,
                    tempGroupPincodeList: pincodeList,
                    isDisplayPincodeListModal: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchPincodeList = tempPincodeList.filter(data => {
                    return (data.Pincode.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    pincode: e.target.value,
                    pincodeErr: "",
                    tempPincodeList: searchPincodeList,
                    isDisplayPincodeList: true
                })
            } else {
                this.setState({
                    pincode: e.target.value,
                    tempPincodeList: pincodeList,
                    isDisplayPincodeList: false
                })
            }
        }
    }

    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {tempPincodeList?.length > 0 && tempPincodeList.map(data => (
                    <li class="list-group-item" key={Math.random()}
                        onClick={() => this.setState({ pincode: data.Pincode, isDisplayPincodeList: false })}
                    >{data.Pincode}</li>
                ))}
            </ul>
        )
    }

    onStateSearch(e, status) {
        const { tempStateList, stateList, tempGroupStateList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchStateList = tempGroupStateList.filter(data => {
                    return (data.Description.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    regStateModal: e.target.value,
                    regStateErrModal: "",
                    tempGroupStateList: searchStateList,
                    isDisplayStateListModal: true
                })
            } else {
                this.setState({
                    regStateModal: e.target.value,
                    tempGroupStateList: stateList,
                    isDisplayStateListModal: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchStateList = tempStateList.filter(data => {
                    return (data.Description.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    regState: e.target.value,
                    regStateErr: "",
                    tempStateList: searchStateList,
                    isDisplayStateList: true
                })
            } else {
                this.setState({
                    regState: e.target.value,
                    tempStateList: stateList,
                    isDisplayStateList: false
                })
            }
        }
    }
    // render state
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {tempStateList?.length > 0 && tempStateList.map(data => (
                    <li class="list-group-item" key={Math.random()}
                        onClick={() => this.callStateList(data.Description, data.Code)}
                    >{data.Description}</li>
                ))}
            </ul>
        )
    }

    callStateList(value, id) {
        const { stateList, stateName, tempStateList } = this.state;
        this.setState({ regState: value, stateId: id, isDisplayStateList: false, });
    }

    onCitySearch(e, status) {
        const { cityList, tempCityList, tempGroupCityList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchCityList = tempGroupCityList.filter(data => {
                    return (data.Description.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    cityModal: e.target.value,
                    cityErrModal: "",
                    tempGroupCityList: searchCityList,
                    isDisplayCityListModal: true
                })
            } else {
                this.setState({
                    cityModal: e.target.value,
                    tempGroupCityList: cityList,
                    isDisplayCityListModal: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchCityList = tempCityList.filter(data => {
                    return (data.Description.toLowerCase().includes(e.target.value.toLowerCase()))
                })
                this.setState({
                    city: e.target.value,
                    cityErr: "",
                    tempCityList: searchCityList,
                    isDisplayCityList: true
                })
            } else {
                this.setState({
                    city: e.target.value,
                    tempCityList: cityList,
                    isDisplayCityList: false
                })
            }
        }
    }
    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList?.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // Email Verify after Input
    verifyEmail(e, status) {
        var value = e.target.value
        if (value != "") {
            var emailError = emailValidator(value)
            if (emailError != '') {
                status == 1 ? this.setState({ emailErrModal: emailError }) : this.setState({ emailErr: emailError })
                return
            } else {
                this.setState({ isLoading: true })
                this.props.verifyVisitorEmail_action(value).then((data) => {
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        if (data.data['ErrMsg'] != "" && data.data['ErrMsg'] != null) {
                            status == 1 ? this.setState({ emailErrModal: data.data['ErrMsg'] }) : status == 2 ? this.setState({ applicantEmailErr: data.data['ErrMsg'] }) : status == 3 ? this.setState({ applicantEmailErrModal: data.data['ErrMsg'] }) : this.setState({ emailErr: data.data['ErrMsg'] })
                        } else {
                            status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                        }
                    } else {
                        this.setState({ isLoading: false })
                        status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                    }
                }).catch((err) => { console.log(err) })
            }
        } else {
            status == 1 ? this.setState({ emailErrModal: "Please enter Email" }) : status == 2 ? this.setState({ applicantEmailErr: "Please enter Email" }) : status == 3 ? this.setState({ applicantEmailErrModal: "Please enter Email" }) : this.setState({ emailErr: "Please enter Email" })
        }
    }

    // On Same As Mobile No Click
    onSameAsMobNoClick(e, status) {
        const { isSameAsMobNo, mobNo, preMobNo, isSameAsMobNoModal, mobNoModal, preMobNoModal } = this.state
        if (status == 1) {
            this.setState({ isSameAsMobNoModal: !isSameAsMobNoModal })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNoModal: mobNoModal,
                    preWhatsAppMobNoModal: preMobNoModal,
                    whatsAppMobNoErrModal: ""
                })
            } else {
                this.setState({ whatsAppMobNoErrModal: "" })

            }
        } else {
            this.setState({ isSameAsMobNo: !isSameAsMobNo })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNo: mobNo,
                    preWhatsAppMobNo: preMobNo,
                    whatsAppMobNoErr: ""
                })
            } else {
                this.setState({
                    whatsAppMobNo: "",

                })

            }
        }
    }

    onGSTchange(value, status) {
        const { gstValidtionList, stateId, stateIdModal } = this.state
        var code = value
        if (status == 1) {
            if (code?.length >= 2) {
                var code = value.slice(0, 2)
                for (var i = 0; i < gstValidtionList?.length; i++) {
                    if (gstValidtionList[i].StateID == stateIdModal) {
                        if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            this.setState({ compInfoGstNoErrModal: "Please enter proper gst no", });
                        }
                        else {
                            this.setState({
                                compInfoGstNoModal: value,
                                compInfoGstNoErrModal: ''
                            })
                        }
                    } else {
                        this.setState({
                            compInfoGstNoModal: value,
                        });
                    }
                }
            }
            else {
                this.setState({
                    compInfoGstNoModal: value,
                });
            }
        } else {
            if (code?.length >= 2) {
                var code = value.slice(0, 2)
                console.log(code?.length, gstValidtionList, 'rere')
                for (var i = 0; i < gstValidtionList?.length; i++) {
                    if (gstValidtionList[i].StateID == stateId) {
                        if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            this.setState({
                                compInfoGstNoErr: "Please enter proper gst no",
                            });
                        }
                        else {
                            this.setState({
                                compInfoGstNo: value,
                                compInfoGstNoErr: ''
                            })
                        }
                    } else {
                        this.setState({ compInfoGstNo: value, });
                    }
                }
            }
            else {
                this.setState({ compInfoGstNo: value, });
            }
        }
    }

    onSelectPrimaryChapter(e, status) {
        const { chapterList, chapterListModal } = this.state
        var id = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            chapterListModal?.length > 0 && chapterListModal.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: false })
                        }
                    }
                }
            })
            this.setState({ chapterListModal: chapterListModal, chapterErrModal: "" })
        } else {
            chapterList?.length > 0 && chapterList.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpen: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpen: false })
                        }
                    }
                }
            })
            this.setState({ chapterList: chapterList, chapterErr: "" })
        }
    }

    onSelectPurpose(e, status) {
        const { visitPurposeList, visitPurposeListModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            visitPurposeListModal?.length > 0 && visitPurposeListModal.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.OtherDetails = ""
                    }

                }
            })
            this.setState({ visitPurposeListModal: visitPurposeListModal, visitPurposeErrModal: "" })
        } else {
            visitPurposeList?.length > 0 && visitPurposeList.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.OtherDetails = ""
                    }

                }
            })
            this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: "" })
        }
    }

    otherDetailsChange(e, status) {
        const { visitPurposeList, visitPurposeListModal } = this.state
        var value = e.target.value
        if (status == 1) {
            visitPurposeListModal?.length > 0 && visitPurposeListModal.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.OtherDetails = value
                } else { data.OtherDetails = "" }
            })
            this.setState({ visitPurposeListModal: visitPurposeListModal, visitPurposeErr: '' })
        } else {
            visitPurposeList?.length > 0 && visitPurposeList.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.OtherDetails = value
                } else { data.OtherDetails = "" }
            })
            this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: '' })
        }
    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2?.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = true
                                }
                            });
                        }
                    });
                } else {
                    level2[i]['isSelect'] = false
                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = false
                                }
                            });
                        }
                    });
                }
            }
        }
        for (let i = 0; i < primaryChapterListData?.length; i++) {
            for (let j = 0; j < level2?.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.isSelect == 1)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['isSelect'] = true
                        } else {
                            primaryChapterListData[i]['isSelect'] = false
                        }
                    }
                }
            }
        }
        setTimeout(() => { this.setState({ level2: level2 }) }, 200);
    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3, dueDate } = this.state
        var tempLevel3 = [];
        for (var j = 0; j < level3?.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {tempLevel3 && tempLevel3.map(level3data => {
                        return (
                            <div class="accordion-body">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                        <button class="accordion-button collapsed " type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                            aria-expanded="false"
                                            aria-controls={'collapse_l2_' + level3data.ChapterID}
                                        >
                                            {level3data.IsCheckbox &&
                                                <input type="checkbox" className="from-left-sp"
                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                    name="" key={level3data.ChapterID} checked={level3data.isSelect}
                                                    onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                            }{formatChapterName(level3data.ChapterName)} </button>
                                    </h2>
                                    {this.recordThree(level3data, level4)}
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
            </>
        );
    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        var modelevel3 = []
        for (let i = 0; i < level3?.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }
        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }
            })
        })
        for (let i = 0; i < level3?.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.isSelect = true
                        }
                    });
                } else {
                    level3[i]['isSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.isSelect = false
                        }
                    });
                }
            }
        }
        for (let i = 0; i < level3?.length; i++) {
            for (let index = 0; index < level2?.length; index++) {
                for (let j = 0; j < primaryChapterListData?.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.isSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['isSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                    console.log("allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['isSelect'] = true
                                    } else { primaryChapterListData[j]['isSelect'] = false }
                                }
                                else {
                                    level2[index]['isSelect'] = false
                                    primaryChapterListData[j]['isSelect'] = false
                                }
                            }
                        }
                    }
                }
            }
        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);
    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4, dueDate } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4?.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {tempLevel4 && tempLevel4.map(level4data => {
                    return (<div class="accordion-body third-step">
                        {level4data.IsCheckbox &&
                            <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.isSelect}
                                disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                        }{formatChapterName(level4data.ChapterName)}
                    </div>)
                })
                }
            </div>
        </>);
    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        for (let i = 0; i < level4?.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['isSelect'] = !level4[i]['isSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []
        for (let i = 0; i < level4?.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }
        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })
        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })
        for (let i = 0; i < tempLevel4?.length; i++) {
            for (let index = 0; index < level3?.length; index++) {
                for (let j = 0; j < primaryChapterListData?.length; j++) {
                    for (let k = 0; k < level2?.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.isSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['isSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.isSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['isSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                                console.log("************** allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['isSelect'] = true
                                                } else {
                                                    primaryChapterListData[j]['isSelect'] = false
                                                }
                                            } else {
                                                level2[k]['isSelect'] = false
                                            }
                                        }
                                        else {
                                            level3[index]['isSelect'] = false
                                            level2[k]['isSelect'] = false
                                            primaryChapterListData[j]['isSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        setTimeout(() => { this.setState({ level4: level4, level3: level3, level2: level2 }) }, 100);
    }

    onSelect(id, status) {
        console.log(id, status)
        const { B2bMeetingList, B2bMeetingListmodal } = this.state
        if (status == 1) {
            for (var i = 0; i < B2bMeetingListmodal?.length; i++) {
                for (var j = 0; j < B2bMeetingListmodal[i].timeSlotList?.length; j++) {
                    if (id == B2bMeetingListmodal[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingListmodal[i].timeSlotList[j].isSelect) {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = false
                        }
                        else {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = true
                        }
                    }
                }
            }
            this.setState({ B2bMeetingListmodal: B2bMeetingListmodal, b2bErrModal: '' })
        } else {
            for (var i = 0; i < B2bMeetingList?.length; i++) {
                for (var j = 0; j < B2bMeetingList[i].timeSlotList?.length; j++) {
                    if (id == B2bMeetingList[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingList[i].timeSlotList[j].isSelect) {
                            B2bMeetingList[i].timeSlotList[j].isSelect = false
                        }
                        else { B2bMeetingList[i].timeSlotList[j].isSelect = true }
                    }
                }
            }
            this.setState({ B2bMeetingList: B2bMeetingList, b2bErr: '' })
        }
    }

    onFilePick = async (e, file, key) => {
        e.preventDefault()
        this.setState({ isVisaUpdated: true })
        const { visitorGroupList } = this.state
        const { } = this.state
        if (file?.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    passportFile: '',
                    passPortFileName: '',
                    passportFileType: '',
                    passportFilePath: '',
                })
                document.getElementById("passportFile").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType?.split("/")
                    }
                    this.setState({ passportFileType: fileTypeList?.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    this.setState({
                        passportFile: '',
                        passPortFileName: '',
                        passportFileType: '',
                        passportFilePath: '',
                    })
                    document.getElementById("passportFile").value = ""
                }
            }
        } else {
            this.setState({
                passportFile: '',
                passPortFileName: '',
                passportFileType: '',
                passportFilePath: '',
            })
            document.getElementById("passportFile").value = ""
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 500, 600, 'JPEG', 80, 0, (uri) => { resolve(uri); },
                "base64", 300, 300,);
        });

    onCrossClick(key, mode) {
        const { isPassportFilePresent } = this.state
        if (isPassportFilePresent) {
            const { isOpen } = this.state
            this.setState({ isOpen: !isOpen })
        } else {
            if (key == 1) {
                if (mode == 1) {
                    this.setState({ passportFile: "", isVisaApplied: false })
                } else {
                    this.setState({ passportFile: "", isVisaApplied: false })
                    document.getElementById("passportFile").value = ""
                }
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
    }

    onCheckedSeminar(e, id, status) {
        const { seminarInterestList, seminarInterestListModal } = this.state
        if (status == 1) {
            seminarInterestListModal?.length > 0 && seminarInterestListModal.map((data) => {
                if (data.SeminarID == id) {
                    if (data.isSelect) {
                        data.isSelect = false
                    } else { data.isSelect = true }
                }
            })
            this.setState({ seminarInterestListModal: seminarInterestListModal, SeminarErrModal: '' })
        } else {
            seminarInterestList?.length > 0 && seminarInterestList.map((data) => {
                if (data.SeminarID == id) {
                    console.log(e.target.value, data.isSelect, id)
                    if (data.isSelect) {
                        data.isSelect = false
                    } else { data.isSelect = true }
                }
            })
            this.setState({ seminarInterestList: seminarInterestList, SeminarErr: '' })
        }
    }

    onSelectDates(e, status) {
        const { daysList, B2bMeetingList, daysListModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            daysListModal?.length > 0 && daysListModal.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysListModal.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
            this.setState({ daysListModal: daysListModal, daysErrModal: "" })
        } else {
            daysList?.length > 0 && daysList.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysList.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            for (var j = 0; j < B2bMeetingList?.length; j++) {
                for (var b = 0; b < B2bMeetingList[j].timeSlotList?.length; b++) {
                    if (!B2bMeetingList[j].timeSlotList[b].IsBooked || B2bMeetingList[j].timeSlotList[b].isSelect) {
                        B2bMeetingList[j].timeSlotList[b].isSelect = false
                    }
                }
            }
            console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
            console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
            this.setState({ daysList: daysList, daysErr: "", B2bMeetingList: B2bMeetingList })
        }
    }

    handleDelete(e) {
        e.preventDefault()
        const { DelegateRegistrationID, AccountID, isDelegateSelect } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaDoc_action(isDelegateSelect == true ? true : false, AccountID, DelegateRegistrationID)
            .then((data) => {
                if (data == null) {
                    this.setState({ isLoading: false })
                    toastError('Something went wrong. Please try again.')
                    return
                }
                if (data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    // sessionStorage.getItem('VisitorTypeID') == 1 && this.setState({ passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    // if (onCrossClickFlagCoordinator) {
                    this.setState({ passportFile: '', isVisaApplied: false, passportFileType: '', passPortFileName: '', isPassportFilePresent: false, passportFilePath: '' })
                    // } else {
                    //     GroupDetailsList.map(item => {
                    //         console.log(AccountIDModal, item, item.AccountID)
                    //         if (item.AccountID == AccountIDModal) {
                    //             item.PassportFile = ''
                    //             item.PassportFileType = ''
                    //             item.PassportFileName = ''
                    //             item.passportFilePath = ''
                    //             item.isPassportFilePresent = false
                    //             item.isVisaApplied = false
                    //         }
                    //     })
                    //     this.setState({ passportFileModal: '', isVisaAppliedModal: false, passportFileTypeModal: '', passPortFileNameModal: '', isPassportFilePresentModal: false, passportFilePathModal: '' })
                    // }
                    this.setState({ isLoading: false, isOpen: false })
                    // sessionStorage.getItem('VisitorTypeID') == 2 && this.setState({ visitorGroupList: visitorGroupList })
                    // this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    getDelegateCredentials(status, selectedVisitorID) {
        return new Promise((resolve => {
            this.props.getDelegateRegistrationCredentials_action(selectedVisitorID ? selectedVisitorID : this.state.selectedVisitorID)
                .then((data) => {
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1) {
                        console.log("Get getDelegateCredentials", data.data[0], JSON.parse(sessionStorage.getItem('loginDataSS')))
                        status == 0 && sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                        status == 1 && sessionStorage.setItem('SelectedDelegateDataSS', JSON.stringify(data.data[0]))
                        // sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionID'])
                        console.log('....................................', status, data.data[0].isCoordinator)

                        if (status == 0 && data.data[0].isCoordinator == true) {
                            this.getCoordinatorDelegate(data.data[0].DelegateRegistrationID, selectedVisitorID)
                            console.log('....................................')
                            this.setState({ coordinatorFN: JSON.parse(sessionStorage.getItem('loginDataSS')).FirstName, coordinatorLN: JSON.parse(sessionStorage.getItem('loginDataSS')).LastName })
                            this.setState({ isCoordinator: true, CoordinatorID: data.data[0].AccountID, coordinatorVisitorRegistrationID: data.data[0].DelegateRegistrationID })
                        }
                        setTimeout(() => {
                            resolve(true)
                        }, 200);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    getCoordinatorVisitor() {
        this.setState({ isLoading: true })
        return new Promise((() => {
            this.props.getCoordinatorVisitor_action(this.state.CoordinatorID)
                .then((data) => {
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong. Please try again.')
                        return
                    }
                    if (data.error != 1) {
                        console.log("Get getCoordinatorVisitor_action", data.data[0])
                        var obj = {}
                        obj.AccountID = this.state.CoordinatorID
                        obj.ExhVisitorID = this.state.coordinatorExhVisitorID
                        obj.PersonIncharge = this.state.coordinatorFN
                        obj.LastNamePersonIncharge = this.state.coordinatorLN
                        data.data.unshift(obj)
                        // if (data.data[0].isCoordinator) {
                        data.data.map(item => {
                            if (item.AccountID == this.state.CoordinatorID) {
                                this.setState({ selectedVisitorID: item.AccountID })
                            }
                        })
                        // sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                        // if (data.data[0].isCoordinator) {
                        this.setState({ visitorList: data.data })
                        // }
                        // this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }
    onDelegateSelect(e) {
        const { isLoading, isCoordinator, delegateList, isDelegateSelect, selectedVisitorID } = this.state
        console.log(e.target.value)
        if (e.target.value != '') {
            this.setState({ selectedVisitorID: e.target.value, isDelegateSelect: true }, () => {
                this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                    this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                        this.getFillList(AccountTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                            this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                                    this.getFillList(B2BTimeslotActionID, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                        this.getFillList(countryIWithCodeActionId, '', '', '', sessionStorage.getItem('ExhCode'), '').then(() => {

                                            this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                this.getFillList(genderActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                    // this.getDrawerDetails()
                                                    this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', 3, '', '').then(() => {
                                                        this.getFillList(companyTurnOverActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                            this.getFillList(visitPurposeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                                this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                                    this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                        this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                            this.getDelegateCredentials(1, e.target.value).then(() => {
                                                                                this.setState({ selectedVisitorID: e.target.value }, () => {
                                                                                    this.getRegistrationDetails(e.target.value)
                                                                                    this.getNotes()
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                    // })
                })


            })

        }
    }

    maxLengthCheck = (object) => {
        if (object.target.value?.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }


    handleSubmit(e) {
        const { agreeTerms, firstName, prename,
            lastName, seminarInterestList, countryId, gender, designation, institute, IECCode, Address1, Address2, Address3, pincode, regState, city, email, website, companywebsite, mobNo, whatsAppMobNo, isSameAsMobNo, telNo, tel1No, compInfoGstNo, visitPurposeList, compInfoPanNo, other, chapterList, companyProfile, totalYears, turnOverId, programList,
            isInterestTwo, daysList, arrivalDate, isCoordinatorAsDelegate, isCoordinator, departureDate, passportFilePath, passportFileType, DelegateRegistrationNo,
            primaryChapterListData, level2, level3, level4, B2bMeetingList, needVisaAssistance, passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate, passCountry, passportFile, passPortFileName,
            AccountTypeID, AccountID, DelegateRegistrationID, isDelegateSelect, PersonProfile, PersonPhoto, PersonPhotoData, PersonPhotoName, PersonPhotoType } = this.state
        e.preventDefault()
        // Is Days Selcted Check
        var Err = true
        // var Err = true
        if (firstName == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErr: "Please enter first name" });
            Err = false
        }
        if (lastName == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErr: "Please enter last name" });
            Err = false
        }
        if (gender == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErr: "Please select Gender" });
            Err = false
        }
        if (designation == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErr: "Please enter designation" });
            Err = false
        }
        if (institute == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErr: "Please enter institue/Organization" });
            Err = false
        }
        if (Address1 == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1Err: "Please enter Address" });
            Err = false
        }
        if (Address2 == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            console.log("Address2")
            this.setState({ Address2Err: "Please enter Address 2" });
            Err = false
        }
        if (Address3 == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            console.log("Address1")
            this.setState({ Address3Err: "Please enter Address 3" });
            Err = false
        }
        if (website == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            console.log("Address1")
            this.setState({ websiteErr: "Please enter website" });
            Err = false
        }
        if (telNo == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            console.log("Address1")
            this.setState({ telephoneErr: "Please enter telephone No" });
            Err = false
        }
        if (tel1No == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            console.log("Address1")
            this.setState({ telephone1Err: "Please enter telephone No 1" });
            Err = false
        }
        if (companywebsite == "" && this.showMandatoryFields(24, 0) && this.showMandatoryFields(24, 2)) {
            console.log("Address1")
            this.setState({ companyWebsiteErr: "Please enter Company Website" });
            Err = false
        }
        if (IECCode == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErr: "Please enter IEC Code " });
            Err = false
        }
        if (mobNo == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErr: "Please enter mobile no" });
            Err = false
        }
        if (whatsAppMobNo == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
            Err = false
        }
        if (regState == "" && countryId == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErr: "Please enter province/state" });
            Err = false
        }
        if (city == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErr: "Please enter city" });
            Err = false
        }
        if (pincode == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErr: "Please enter Pincode" });
            Err = false
        }
        if (email == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErr: "Please enter Email" });
            Err = false
        }
        if (email != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                Err = false
                // return
            }
        }
        if (companyProfile == "" &&
            !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            // this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)
        ) {
            this.setState({ companyProfileErr: "Please enter Company profile" });
            Err = false
        }
        if (countryId == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErr: "Please select country" });
            Err = false
        }
        if (totalYears == "" &&
            !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            //  this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)
        ) {
            this.setState({ totalYearsErr: "Please enter Total Years the Company Is Operational" });
            Err = false
        }
        if (turnOverId == "" &&
            !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ turnOverErr: "Please select Company turnOver" });
            Err = false
        }
        if (arrivalDate == "" && this.showMandatoryFields(27, 0) && this.showMandatoryFields(27, 2)) {
            this.setState({ arrivalDateErr: "Please select arrival Date" });
            Err = false
        }
        if (departureDate == "" && this.showMandatoryFields(28, 0) && this.showMandatoryFields(28, 2)) {
            this.setState({ departureDateErr: "Please select Departure Date" });
            Err = false
        }
        if (AccountTypeID == "") {
            this.setState({ AccountTypeIDErr: "Please select Account type" });
            Err = false
        }
        const selectedChapter = chapterList.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })
        if (chapterListData.length == 0 && !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ chapterErrModal: "Please Select atleast 1 Industry segment" });
            Err = false
        }

        const purposeOfVisitlist = visitPurposeList.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "OtherDetails": data.OtherDetails
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && (data.OtherDetails == '' || data.OtherDetails == null) ? true : false
            console.log('datadatadata', data)
            // var data = {
            //     "PurposeofVisitID": data.PurposeofVisitID,
            //     "OtherDetails": data.otherDetail
            // }
            // purposeOfVisitlistData.push(data)
        })
        console.log('datadatadata', purposeOfVisitlistData, otherPOV)
        if (otherPOV && !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            // && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)
        ) {
            console.log("purposeOfVisitlistData")
            this.setState({ visitPurposeErr: "Please enter other purpose of visit" })
            Err = false
        }
        if (purposeOfVisitlistData?.length == 0 && !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            //  && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)
        ) {
            this.setState({ visitPurposeErr: "Please select Purpose of visit" })
            Err = false
        }
        const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })


        var selectedDays = []
        selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (list?.length == 0 && (!isInterestTwo && this.showMandatoryFields(34, 0) && this.showMandatoryFields(34, 2) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2)))) {
            this.setState({ daysErr: "Please select Visit Days" })
            Err = false
        }

        var B2bList = []
        // B2bList = B2bMeetingListmodal.filter(data => data.isSelect == true)
        B2bMeetingList?.length > 0 && B2bMeetingList.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList?.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })

        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,
                // "OtherNames": ''

            }
            chapterListData2.push(data)
        })
        if (chapterListData2.length == 0 && !this.checkCoordinatorORDelegate() && this.state.AccountID == 10
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ ChapterHallErrModal: "Please Select atleast 1 Product" });
            Err = false
        }
        // if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2) && !needVisaAssistance) {
        //     console.log("visaErr")
        //     this.setState({ visaErr: "Please select Visa Assistance" })
        //     Err = false
        // }
        var visaErr = false

        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
                visaErr = true
                Err = false
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
                visaErr = true
                Err = false
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
                visaErr = true
                Err = false
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
                visaErr = true
                Err = false
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                visaErr = true
                Err = false
            }
            if (passCountry == "") {
                this.setState({ passCountryErr: "Please Select Country " });
                visaErr = true
                Err = false
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
                visaErr = true
                Err = false
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    visaErr = true
                    return
                }
            }
            if (visaErr) {
                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErr: "Please Fill Visa Assistance" })
                    Err = false
                }
            } else {
                this.setState({ visaErr: "" })
            }
        }
        setTimeout(() => {
            // const { countryId, attendeeTypeId, firstName, city, preMobNo, mobNo, regState, designation, photoFile, lastName, photoIdFile, gender,
            //     instfirstitute, Name, preWhatsAppMobNo, whatsAppMobNo, pincode, email, firstNameErr, lastNameErr, designationErr,
            //     instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, institute, cityErr, pincodeErr, emailErr, preName, middleName,
            //     isSameAsMobNo, website, preTelNo, preTel1No, AccountID, ExhVisitorID, telNo, tel1No, countryIdErr, isOtherPreName, otherName, attendeeTypeErr, daysErr } = this.state

            if (Err
            ) {
                if (Err) {
                    var agreeTermsErr = true
                    if (!agreeTerms && this.showMandatoryFields(29, 2)) {
                        agreeTermsErr = false
                    }
                    if (agreeTermsErr) {
                        var ExhProgramList = []
                        var ExhProgramDateList = []
                        var ExhProgramCategory = []
                        programList.map(item => {
                            if (item.isSelect) {
                                if (!ExhProgramList.includes(item.ExhProgramID)) {
                                    ExhProgramList.push(item.ExhProgramID)
                                }
                                if (!ExhProgramDateList.includes(item.ExhProgramDateID)) {
                                    ExhProgramDateList.push(item.ExhProgramDateID)
                                }
                                item.catogary.length > 0 && item.catogary.map(item2 => {
                                    if (item2.isSelect) {
                                        if (!ExhProgramCategory.includes(item2.ExhProgramCategoryID)) {
                                            ExhProgramCategory.push(item2.ExhProgramCategoryID)
                                        }
                                    }
                                })
                            }
                        })
                        this.setState({ isLoading: true })
                        /// Setting data in session storage For Insert Next
                        this.props.delegateRegistrationCombineSubmit_action(AccountID, DelegateRegistrationID, countryId, AccountTypeID, this.state.isOtherPreName ? this.state.otherName : prename, firstName, lastName, gender, designation, institute, compInfoGstNo, compInfoPanNo, IECCode, Address1, Address2, Address3,
                            website, mobNo, whatsAppMobNo, isSameAsMobNo, regState, city, pincode, email, telNo, tel1No, companyProfile, companywebsite, totalYears, turnOverId, arrivalDate, departureDate, isCoordinator, isCoordinatorAsDelegate, isInterestTwo,
                            needVisaAssistance, passName, applicantEmail, applicantMobNo, passNo, passDate, passExipryDate, passCountry, passportFilePath, passportFile, passPortFileName, passportFileType, chapterListData, purposeOfVisitlistData, selectedDays,
                            seminarInterestListData, filerArray, B2bListfinal, agreeTerms, isDelegateSelect == true ? true : false, PersonProfile, PersonPhoto, PersonPhotoData, PersonPhotoName, PersonPhotoType, DelegateRegistrationNo, ExhProgramList, ExhProgramDateList, ExhProgramCategory, this.state.Source)
                            .then((data) => {
                                if (data == null) {
                                    this.setState({ isLoading: false })
                                    toastError('Something went wrong. Please try again.')
                                    return
                                }
                                if (data.error != 1) {
                                    console.log("Registration Next", isDelegateSelect)
                                    this.getRegistrationDetails(AccountID)
                                    this.setState({ isLoading: false })
                                    // sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                                    // sessionStorage.setItem('DelegateTypeID', AccountTypeID)
                                    // this.props.navigate('/delegateAdditionalDetails', {
                                    //     state: {
                                    //         // ExhVisitorID: data.data[0]['ExhVisitorID'],
                                    //         // countryID: countryId
                                    //     }
                                    // })
                                    setTimeout(() => {
                                        toastSuccess("data Updated successfully")
                                    }, 500);
                                } else {
                                    this.setState({ isLoading: false })
                                    // console.log
                                    toastError(data.msg);
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        toastError("Please agree to the Conditions")
                    }
                }
                else {
                    toastError("Enter Mandatory Fields")
                }
            } else {
                toastError("Enter Mandatory Fields")
            }
        }, 200);
    }

    getNotes() {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList, note } = this.state
        // this.setState({ isLoading: true })
        this.props.getExhNoteDetails_action(sessionStorage.getItem('sessionExhibitionID'))
            .then((data) => {
                if (data == null) {
                    this.setState({ isLoading: false })
                    toastError('Something went wrong. Please try again.')
                    return
                }
                if (data.error != 1) {
                    console.log(data.data)
                    var notesArr = []
                    data.data?.length > 0 && data.data.map(item => {
                        if (item.NoteType == 'Delegate Registration') {
                            notesArr.push(item.Description)
                        }
                    })
                    this.setState({ note: notesArr })
                }
            })
    }

    onSelectInterest(e, status) {
        const { daysList, isInterestTwo, B2bMeetingList, isInterestTwoModal } = this.state
        var checked = e.target.checked
        if (status == 1) {
            this.setState({ isInterestTwoModal: !isInterestTwoModal })
        } else {
            this.setState({ isInterestTwo: !isInterestTwo })
            if (checked) {
                this.setState({ daysErr: false })
                for (var i = 0; i < daysList?.length; i++) {
                    daysList[i].isSelect = false
                }
                this.setState({ daysList: daysList, b2bErr: '' })
            }
            else {
                for (var i = 0; i < B2bMeetingList?.length; i++) {
                    for (var a = 0; a < B2bMeetingList[i].timeSlotList?.length; a++) {
                        if (!B2bMeetingList[i].timeSlotList[a].IsBooked) {
                            B2bMeetingList[i].timeSlotList[a].isSelect = false
                        }
                    }
                }
                this.setState({ B2bMeetingList: B2bMeetingList, b2bErr: '' })
            }
        }
    }

    getFieldList(typeId) {
        // this.setState({ isLoading: true })
        this.props.getDelegateFirldList_action(typeId)
            .then((data) => {
                if (data == null) {
                    this.setState({ isLoading: false })
                    toastError('Something went wrong. Please try again.')
                    return
                }
                if (data.error != 1) {
                    var showFieldListArr = []
                    if (data.data[1] != null) {
                        if (data.data[1]?.length > 0) {
                            for (var i = 0; i < data.data[1]?.length; i++) {
                                var obj = {
                                    'id': data.data[1][i].FieldID, 'mandatory': data.data[1][i].IsMandatory, 'name': data.data[1][i].FieldName
                                }
                                showFieldListArr.push(obj)
                            }
                        }
                    }
                    console.log('data.data', showFieldListArr)
                    sessionStorage.setItem('showFieldList', JSON.stringify(showFieldListArr))
                    this.setState({
                        showFieldList: showFieldListArr
                    })
                }
            })
    }

    handleSearchChange = (event, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: event.target.value, isOpenDropDownState: event.target.value?.length > 0, tempStateList: this.filterItems(event.target.value, mode, status), focusedIndexState: -1 });
            }
            else if (status == 1) {
                console.log(event, 'event')
                this.setState({ regStateModal: event.target.value, isOpenDropDownStateModal: event.target.value?.length > 0, tempStateListModal: this.filterItems(event.target.value, mode, status), focusedIndexStateModal: -1 });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: event.target.value, isOpenDropDownCity: event.target.value?.length > 0, tempCityList: this.filterItems(event.target.value, mode, status), focusedIndexCity: -1 });
            }
            else if (status == 1) {
                this.setState({ cityModal: event.target.value, isOpenDropDownCityModal: event.target.value?.length > 0, tempCityListModal: this.filterItems(event.target.value, mode, status), focusedIndexCityModal: -1 });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: event.target.value, isOpenDropDownPin: event.target.value?.length > 0, tempPincodeList: this.filterItems(event.target.value, mode, status), focusedIndexPin: -1 });
            }
            else if (status == 1) {
                this.setState({ pincodeModal: event.target.value, isOpenDropDownPinModal: event.target.value?.length > 0, tempPincodeListModal: this.filterItems(event.target.value, mode, status), focusedIndexPinModal: -1 });
            }
        }
    };

    filterItems = (searchTerm, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                console.log('this.state.stateListModal', this.state.stateListModal)
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 1) {
            if (status == 0) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 2) {
            if (status == 0) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        }
    };

    // Handle selecting an option from the dropdown
    handleSelect = (option, mode, status) => {
        console.log(option)
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: -1, tempStateList: [], isOpenDropDownState: false, }, () => {
                    this.callStateList(option.Description, option.Code)
                });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: -1, tempCityListModal: [], isOpenDropDownStateModal: false, });
                this.callStateListModal(option.Description, option.Code)

            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: option.Description, focusedIndexCity: -1, tempCityList: [], isOpenDropDownCity: false, });
            } else if (status == 1) {
                this.setState({ cityModal: option.Description, focusedIndexCityModal: -1, tempStateListModal: [], isOpenDropDownCityModal: false, });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: option.Pincode, focusedIndexPin: -1, tempCityList: [], isOpenDropDownPin: false, });
            } else if (status == 1) {
                this.setState({ pincodeModal: option.Pincode, focusedIndexPinModal: -1, tempCityListModal: [], isOpenDropDownPinModal: false, });
            }
        }
    };

    handleKeyDown = (e, mode, status) => {
        const { focusedIndexState, tempPincodeList, tempPincodeListModal, focusedIndexPin, focusedIndexPinModal, tempStateList, focusedIndexStateModal, tempStateListModal, tempCityList, focusedIndexCity, focusedIndexCityModal, tempCityListModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexState: Math.min(focusedIndexState + 1, tempStateList?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexState: Math.max(focusedIndexState - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexState >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateList[focusedIndexState], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    console.log(tempStateListModal?.length)
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexStateModal: Math.min(focusedIndexStateModal + 1, tempStateListModal?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexStateModal: Math.max(focusedIndexStateModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexStateModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateListModal[focusedIndexStateModal], mode, status);
                }
            }
        } else if (mode == 1) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCity: Math.min(focusedIndexCity + 1, tempCityList?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCity >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityList[focusedIndexCity], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCityModal: Math.min(focusedIndexCityModal + 1, tempCityListModal?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCityModal: Math.max(focusedIndexCityModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCityModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityListModal[focusedIndexCityModal], mode, status);
                }
            }
        } else if (mode == 2) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPin: Math.min(focusedIndexPin + 1, tempPincodeList?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPin: Math.max(focusedIndexPin - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPin >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeList[focusedIndexPin], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPinModal: Math.min(focusedIndexPinModal + 1, tempPincodeListModal?.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPinModal: Math.max(focusedIndexPinModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPinModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeListModal[focusedIndexPinModal], mode, status);
                }
            }
        }
    };

    handleHover = (index, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: index });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: index });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ focusedIndexCity: index });
            } else if (status == 1) {
                this.setState({ focusedIndexCityModal: index });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ focusedIndexPin: index });
            } else if (status == 1) {
                this.setState({ focusedIndexPinModal: index });
            }
        }
    };

    scrollIntoView = (mode, status) => {
        // console.log(mode, status)
        const { focusedIndexState, focusedIndexStateModal, focusedIndexPin, focusedIndexPinModal, focusedIndexCity, focusedIndexCityModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexState];
                if (!focusedItem) return;
                console.log('.00..0.0', dropdownMenu, dropdownMenu.getBoundingClientRect())

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom < dropdownBottom) {
                //     dropdownMenu.scrollTop =-50;
                //     console.log(dropdownMenu.scrollTop )
                // }
                // else if (itemTop > dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 1) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexCity];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 2) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexPin];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        }
    };

    showMandatoryFields(FieldID, mode) {
        const { showFieldList } = this.state
        var isFieldAvailable = false
        for (var i = 0; i < showFieldList?.length; i++) {
            // console.log(showFieldList[i], FieldID)
            if (showFieldList[i].id == FieldID) {
                isFieldAvailable = true
                if (mode == 0) {
                    return true
                } else if (mode == 1) {
                    return showFieldList[i].name
                } else if (mode == 2) {
                    if (showFieldList[i].mandatory) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        }
        if (!isFieldAvailable) {
            return false
        }
    }

    cancle() {
        window.history.back();
    }

    checkCoordinatorORDelegate() {
        const { isLoading, isOtherPreName, otherName, firstName, firstNameErr, prename,
            PersonPhotoType, PersonPhotoTypeModal, PersonProfileErr, PersonProfileModal, isCoordinator, PersonProfileModalErr, isB2bMeetingShow } = this.state
        if (sessionStorage.getItem('SelectedDelegateDataSS') != null) {
            return JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).isCoordinator
        } else {
            return isCoordinator
        }
    }


    selectProgram(flag, id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        if (flag == 1) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 2) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 3) {
            var beforeValue = false
            var DateId = ''
            var DateValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        DateId = programList[i].ExhProgramDateID
                        if (programList[i].catogary[j].isSelect) {
                            beforeValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        if (beforeValue) {
                            programList[i].catogary[j].isSelect = false
                        } else {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    for (var j = 0; j < programList[i].catogary.length; j++) {
                        if (programList[i].catogary[j].isSelect) {
                            DateValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    if (DateValue) {
                        programList[i].isSelect = true

                    } else {
                        programList[i].isSelect = false
                    }
                }
            }
        }
        this.setState({ programList: programList })
    }

    checkSelectedProgram(id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var beforeValue = false
        for (var i = 0; i < programList.length; i++) {
            if (programList[i].ExhProgramID == id) {
                if (programList[i].isSelect) {
                    beforeValue = true
                    break
                }
            }
        }
        return beforeValue
    }

    checkselectallprogram() {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var beforeValue = true
        var uniqueArr = []
        for (var i = 0; i < programList.length; i++) {
            if (!uniqueArr.includes(programList[i].ExhProgramID)) {
                uniqueArr.push(programList[i].ExhProgramID)
            }
            // if (programList[i].isSelect) {
            //     if (programList[i].isSelect) {
            //         beforeValue = true
            //         break
            //     }
            // }
        }
        for (var j = 0; j < uniqueArr.length; j++) {
            for (var i = 0; i < programList.length; i++) {
                if (uniqueArr[j] == programList[i].ExhProgramID) {
                    if (!programList[i].isSelect) {
                        beforeValue = false
                    }
                    break
                }
            }
        }
        console.log(uniqueArr, 'programList')
        return beforeValue
    }



    render() {
        const { isLoading, isOtherPreName, otherName, firstName, firstNameErr, prename,
            lastName, lastNameErr, genderList, countryIdErr, seminarInterestList, countryId, programList,
            countryList, preMobNo, preWhatsAppMobNo, tempStateList, tempCityList, tempPincodeList,
            gender, genderErr, designation, designationErr, institute, instituteErr, IECCode, mainB2bArr, dueDate,
            IECCodeErr, Address1, Address2, Address3, Address1Err, pincode, pincodeErr, regState, AccountTypeID,
            regStateErr, city, cityErr, email, emailErr, website, companywebsite, mobNo, mobNoErr, Source,
            whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, telNo, preTelNo, tel1No, preTel1No, isfromAdmin,
            compInfoGstNo, compInfoGstNoErr, visitPurposeList, visitPurposeErr, compInfoPanNoErr,
            compInfoPanNo, chapterList, companyProfile, isOpen, totalYears, totalYearsErr, companyProfileErr,
            isInterestTwo, daysList, arrivalDate, arrivalDateErr, isCoordinator, departureDate, departureDateErr,
            daysErr, agreeTerms, isOpenDropDownPin, isOpenDropDownState, isOpenDropDownCity, primaryChapterListData,
            level2, level3, level4, ChapterHallErr, B2bMeetingList, needVisaAssistance, passName, passNameErr,
            applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo,
            passNoErr, passDate, passDateErr, passExipryDate, passExipryDateErr, passCountryErr, passCountry,
            isPassportFilePresent, isVisaApplied, passportFileErr, passportFile, passPortFileName, AccountTypeName,
            selectedVisitorID, delegateList, PersonPhoto, PersonProfile, PersonPhotoData, PersonPhotoDataModal, PersonPhotoErr,
            PersonPhotoModalErr, PersonPhotoModal, PersonPhotoName, PersonPhotoNameModal, PersonPhotoPreview, PersonPhotoPreviewModal,
            PersonPhotoType, PersonPhotoTypeModal, PersonProfileErr, PersonProfileModal, PersonProfileModalErr, isB2bMeetingShow } = this.state
        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const showProgramTable = programList.some(obj => obj.isSelect == true)

        console.log('B2bMeetingList------->', delegateList, selectedVisitorID, JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')))
        return (
            <>
                {isLoading ? (<Loader></Loader>) : (null)}
                <ToastContainer />
                <div>
                    {sessionStorage.getItem("RoleIDSS") == 15 ?
                        <>
                            <VisitorHeader2 />
                            <DelegateDrawer />
                        </> :
                        <>
                            <HeaderWithLogo />
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed with-dr-container">
                                    <h6 className="mb-0 px-2 py-2 text-white">{AccountTypeName} Update</h6>
                                </div>
                            </div>
                        </>
                    }
                    <div
                        className={`${sessionStorage.getItem("RoleIDSS") == 15 ? "mt-3" : "mt-0"} main-content app-content with-dr-container`} >
                        {/* <div> */}
                        {sessionStorage.getItem("RoleIDSS") == 15 ?
                            <DelegateTopMenu /> :
                            <AdminDrawer />
                        }
                        {/* </div> */}
                        <div
                            className={`${sessionStorage.getItem("RoleIDSS") == 15 ? "mt-0" : "admin-top-space"} "main-content app-content no-scroll`}
                            style={{ marginInlineStart: 0 }}
                        >
                            <div className="side-app delegate-form-page">
                                {/* <div className="container-fluid p-0">
                            <div className="row">
                                <div
                                    className="step-name" style={{ backgroundColor: "#bc202b", color: "#fff;", marginLeft: "225px" }}
                                >
                                    <p>ITME Africa &amp; Middle East 2023 Visitor Registration form</p>
                                </div>
                            </div>
                        </div> */}
                                {/* No side margin: it was full width on phones, so ml-2 pushed it past the right edge */}
                                {isCoordinator && <div className='col-md-4 p-0 mt-3 mb-3'>
                                    <div className=" mb-0">
                                        <label className=''>Delegate List</label>
                                        <select className="form-control select2 select-hidden-accessible pl-0"
                                            style={{ width: "100%" }}
                                            value={selectedVisitorID}
                                            onChange={e => this.onDelegateSelect(e)}
                                        >
                                            {
                                                delegateList?.length > 0 && delegateList.map((item) => (
                                                    <option key={item.AccountID} value={item.AccountID}>{item.PersonIncharge_FirstName} {item.PersonIncharge_LastName}</option>
                                                ))
                                            }
                                        </select>

                                    </div>
                                </div>}
                                <style>{`
                                    .delegate-form-acc .accordion-body {
                                        padding-top: 0.5rem !important;
                                    }
                                    .delegate-form-acc .accordion-body > .one-section {
                                        margin-top: 0 !important;
                                    }
                                    .delegate-form-acc .accordion-body > .one-section > [class*="col"]:first-child > .row.mt-3,
                                    .delegate-form-acc .accordion-body > .one-section > [class*="col"]:first-child > .row > [class*="col"].mt-2 {
                                        margin-top: 0 !important;
                                    }
                                    @media (max-width: 767px) {
                                        .app-content .side-app.delegate-form-page {
                                            padding-left: 0 !important;
                                            padding-right: 0 !important;
                                        }
                                        .delegate-form-page .delegate-form-acc {
                                            margin-left: 0 !important;
                                            margin-right: 0 !important;
                                        }
                                    }
                                    /* Tablets: equal ~8px gap at both edges. The content already carries
                                       ~8px on its right, so the page pads only the left side */
                                    @media (min-width: 768px) and (max-width: 991.98px) {
                                        .app-content .side-app.delegate-form-page {
                                            padding-left: 8px !important;
                                            padding-right: 0 !important;
                                        }
                                        .delegate-form-page .delegate-form-acc {
                                            margin-left: 0 !important;
                                            margin-right: 0 !important;
                                        }
                                    }
                                `}</style>
                                <div className="combine-section">
                                    <div className="needs-validation after-step mt-1 ml-2 delegate-form-acc">
                                        <div id="Menu1">
                                            <div id="section-1">
                                                {false && <div className="accordion" id="accordionExample">
                                                    <div className="accordion-item">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button className={`accordion-button`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h1"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h1"
                                                            >Account Type
                                                            </button>
                                                        </h5>
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h1">
                                                            <div className="accordion-body">
                                                                <div className="one-section">
                                                                    {/* <div className="containerfluid">
                                                                        <div className="row mt-2">
                                                                            <div className="col-md-12">
                                                                                <div className="p-1 title-bg">
                                                                                    <p className="mb-0">Account Type</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-xl-3">
                                                                                {/* <div className="d-flex">
                                                                                    <label className="mt-1 w-auto" >
                                                                                        Select Account Type
                                                                                        <span className="text-red">*</span>

                                                                                    </label>
                                                                                </div> */}
                                                                                <select className="form-control" value={this.state.AccountTypeID} disabled
                                                                                    onChange={(e) => this.setState({ AccountTypeID: e.target.value, AccountTypeIDErr: '' })}
                                                                                >
                                                                                    <option value={''}>Select Type</option>
                                                                                    {
                                                                                        this.state.accountTypeList?.length > 0 && this.state.accountTypeList.map((data) => (
                                                                                            <option key={data.AccountTypeID} value={data.AccountTypeID} >{data.Name}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                                {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{this.state.AccountTypeIDErr}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="accordion" id="accordionExample">
                                                    <div className="accordion-item">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button className={`accordion-button`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h2"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h2"
                                                            >{this.state.VisitorTypeID == 2 ? 'Coordinator Information' : 'Personal Information'}
                                                            </button>
                                                        </h5>
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h2">
                                                            <div className="accordion-body compact-section-body">
                                                                <div className="one-section">
                                                                    {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg">
                                                                    <p className="mb-0">{this.state.VisitorTypeID == 2 ? 'Coordinator Information' : 'Personal Information'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                    {/* {this.state.VisitorTypeID == 2 && <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-12 col-sm-6 col-lg-3">
                                                        <label className="d-flex mt-3">
                                                            <input type="checkbox" name="fav_language"
                                                                value={this.state.isCoordinatorVisit} checked={this.state.isCoordinatorVisit}
                                                                onClick={(e) => this.setState({ isCoordinatorVisit: !this.state.isCoordinatorVisit })}
                                                            />
                                                            is Coordinator Visiting?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>} */}
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(2, 0) && <div className="col-xl-3 mb-1">
                                                                                <label className="mt-1">
                                                                                    First Name{this.showMandatoryFields(2, 2) && <span className="text-red">*</span>}
                                                                                </label>
                                                                                <div className="name-input-group">
                                                                                    <select
                                                                                        className="form-control name-prefix"
                                                                                        // id="validationCustom03"
                                                                                        required=""
                                                                                        // disabled
                                                                                        value={prename}
                                                                                        onChange={(e) => this.setState({
                                                                                            prename: e.target.value,
                                                                                            isOtherPreName: e.target.value == "Other" ? true : false
                                                                                        })}
                                                                                    >
                                                                                        <option value="Mr">Mr</option>
                                                                                        <option value="Ms">Ms</option>
                                                                                        <option value="DR">DR</option>
                                                                                        <option value="Prof">Prof</option>
                                                                                        <option value="Other">Other</option>
                                                                                    </select>
                                                                                    {
                                                                                        isOtherPreName &&
                                                                                        <input
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            type="text"
                                                                                            className="form-control name-other"
                                                                                            maxLength={'40'}
                                                                                            value={otherName}
                                                                                            onChange={e => this.setState({ otherName: e.target.value })}
                                                                                            placeholder={'Other'}
                                                                                        />
                                                                                    }
                                                                                    <input
                                                                                        type="text"
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        className="form-control name-no"
                                                                                        maxLength={'50'}
                                                                                        // disabled
                                                                                        value={firstName}
                                                                                        onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ firstName: e.target.value, firstNameErr: '' })}
                                                                                    // onChange={(e) => /^[A-Za-z\s]+$/.test(e.target.value) ? this.setState({ firstName: e.target.value, firstNameErr: "" }) : null}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block'>{firstNameErr}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(3, 0) && <div className="col-xl-3 mb-1">
                                                                                <label className="mt-1">Last Name
                                                                                    {this.showMandatoryFields(2, 2) && <span className="text-red">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={lastName} maxLength={'50'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => /^[A-Za-z\s]+$/.test(e.target.value) ? this.setState({ lastName: e.target.value, lastNameErr: "" }) : null}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErr}</span>}
                                                                            </div>}
                                                                            {this.showMandatoryFields(20, 0) && <div className="col-xl-3">
                                                                                <div className="d-flex">
                                                                                    <label className="mt-1 w-auto" >
                                                                                        Select Country
                                                                                        {this.showMandatoryFields(20, 2) && <span className="text-red">*</span>}

                                                                                    </label>
                                                                                </div>
                                                                                <select className="form-control" value={countryId} disabled
                                                                                    onChange={(e) => this.onCountrySelect(e)}
                                                                                >
                                                                                    <option value={''}>Select Your Country</option>
                                                                                    {
                                                                                        countryList?.length > 0 && countryList.map((data) => (
                                                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                                {<span className='text-danger text-start text-left d-block'>{countryIdErr}</span>}
                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(4, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <div className="d-flex">
                                                                                    <label className="">
                                                                                        Gender
                                                                                        {this.showMandatoryFields(4, 2) && <span className="text-red">*</span>}

                                                                                    </label>
                                                                                </div>
                                                                                <select className="form-control" value={gender}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => e.target.value != '' ? this.setState({ gender: e.target.value, genderErr: '' }) : null}
                                                                                >
                                                                                    <option value={''}>Select Your Gender</option>
                                                                                    {
                                                                                        genderList?.length > 0 && genderList.map((data) => (
                                                                                            <option key={data.GenderID} value={data.GenderID} >{data.Name}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                                {<span className='text-danger text-start text-left d-block'>{genderErr}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(5, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex ">
                                                                                    Designation{this.showMandatoryFields(5, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={designation} maxLength={'50'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ designation: e.target.value, designationErr: "" })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{designationErr}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(6, 0) && <div className="col-sm-6">
                                                                                <label className="d-flex ">
                                                                                    Institute/Organisation{this.showMandatoryFields(6, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={institute} maxLength={'500'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ institute: e.target.value, instituteErr: "" })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{instituteErr}</span>}

                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(10, 0) && <div className="col-sm-6">
                                                                                <label className="d-flex ">
                                                                                    Address 1{this.showMandatoryFields(10, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={Address1} maxLength={'1000'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ Address1: e.target.value, Address1Err: "" })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{Address1Err}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(11, 0) && <div className="col-sm-6">
                                                                                <label className="d-flex ">
                                                                                    Address 2{this.showMandatoryFields(11, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={Address2} maxLength={'1000'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ Address2: e.target.value, Address2Err: '' })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.Address2Err}</span>}

                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(12, 0) && <div className="col-sm-6">
                                                                                <label className="d-flex ">
                                                                                    Address 3{this.showMandatoryFields(12, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={Address3} maxLength={'1000'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ Address3: e.target.value, Address3Err: '' })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.Address3Err}</span>}


                                                                            </div>}
                                                                            {this.showMandatoryFields(9, 0) && <div className="col-sm-6">
                                                                                <label className="d-flex ">
                                                                                    IEC Code (Importer-Exporter Code){this.showMandatoryFields(9, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={IECCode} maxLength={'50'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => this.setState({ IECCode: e.target.value, IECCodeErr: "" })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{IECCodeErr}</span>}

                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(15, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">
                                                                                    Pincode/Zipcode
                                                                                    {countryId == "91" && this.showMandatoryFields(15, 2) && <span className="red-star text-danger">*</span>}
                                                                                </label>
                                                                                {/* {
                                                            countryId == "91" &&
                                                            // <input type="number" className="form-control" value={pincode}
                                                            //     maxLength={6} onChange={(e) => this.onPincodeSearch(e)}
                                                            // />
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={6} onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e) : null}
                                                            />
                                                        }
                                                        {
                                                            countryId != "91" &&
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e)}
                                                                onInput={toInputUppercase}
                                                            />
                                                        }
                                                        {isDisplayPincodeList && this.renderPincodeList()} */}
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    // placeholder="Search..."
                                                                                    value={pincode}
                                                                                    maxLength={countryId == "91" ? 6 : 10}
                                                                                    // onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 0) : null}
                                                                                    // onChange={this.handleSearchChange}
                                                                                    onFocus={() => pincode?.length > 0 && this.setState({ isOpenDropDownPin: true })}
                                                                                    // onBlur={() => this.setState({ isOpenDropDownPin: false })}
                                                                                    onBlur={() => setTimeout(() => {
                                                                                        this.setState({ isOpenDropDownPin: false })
                                                                                    }, 500)}
                                                                                    onKeyDown={(e) => this.handleKeyDown(e, 2, 0)}
                                                                                />

                                                                                {/* Dropdown options - shown only if there are results */}
                                                                                {isOpenDropDownPin && tempPincodeList?.length > 0 && (
                                                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                        {tempPincodeList.map((item, index) => (
                                                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 0)}
                                                                                                // className={this.state.focusedIndexPin === index ? 'text-white' : 'none'}
                                                                                                style={{
                                                                                                    whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                    backgroundColor: this.state.focusedIndexPin === index ? '#a4c2df' : 'transparent',
                                                                                                }}
                                                                                                onMouseEnter={() => this.handleHover(index, 2, 0)}
                                                                                            >
                                                                                                {item.Pincode}
                                                                                            </Dropdown.Item>
                                                                                        ))}
                                                                                    </Dropdown.Menu>
                                                                                )}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                                {isDisplayPincodeList && this.renderPincodeList()}
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                                {isDisplayPincodeList && this.renderPincodeList()} */}
                                                                            </div>}
                                                                            {this.showMandatoryFields(14, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">
                                                                                    State/Province
                                                                                    {countryId == "91" && this.showMandatoryFields(14, 2) && <span className="red-star text-danger">*</span>}
                                                                                </label>
                                                                                {/* <input type="text" className="form-control" value={regState} maxLength={'50'}
                                                            onChange={(e) => this.onStateSearch(e)}
                                                        />
                                                        {isDisplayStateList && this.renderStateList()} */}
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    // placeholder="Search..."
                                                                                    value={regState}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                                    // onChange={this.handleSearchChange}
                                                                                    onFocus={() => regState?.length > 0 && this.setState({ isOpenDropDownState: true })}
                                                                                    onBlur={() => setTimeout(() => {
                                                                                        this.setState({ isOpenDropDownState: false })
                                                                                    }, 500)}
                                                                                    onKeyDown={(e) => this.handleKeyDown(e, 0, 0)}
                                                                                />

                                                                                {/* Dropdown options - shown only if there are results */}
                                                                                {isOpenDropDownState && tempStateList?.length > 0 && (
                                                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                        {tempStateList.map((item, index) => (
                                                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 0)}
                                                                                                // className={this.state.focusedIndexState === index ? 'text-white' : 'none'}
                                                                                                style={{
                                                                                                    whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                    backgroundColor: this.state.focusedIndexState === index ? '#a4c2df' : 'transparent',
                                                                                                }}
                                                                                                onMouseEnter={() => this.handleHover(index, 0, 0)}
                                                                                            >
                                                                                                {item.Description}
                                                                                            </Dropdown.Item>
                                                                                        ))}
                                                                                    </Dropdown.Menu>
                                                                                )}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{regStateErr}</span>}
                                                                            </div>}

                                                                            {this.showMandatoryFields(13, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">City
                                                                                    {this.showMandatoryFields(13, 2) && <span className="red-star text-danger">*</span>}
                                                                                </label>
                                                                                {/* <input type="text" className="form-control" value={city} maxLength={'50'}
                                                            onChange={(e) => this.onCitySearch(e)} />
                                                        {isDisplayCityList && this.renderCityList()} */}
                                                                                <Form.Control
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    type="text"
                                                                                    // placeholder="Search..."
                                                                                    value={city}
                                                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 0)}
                                                                                    // onChange={this.handleSearchChange}
                                                                                    onFocus={() => city?.length > 0 && this.setState({ isOpenDropDownCity: true })}
                                                                                    onBlur={() => setTimeout(() => {
                                                                                        this.setState({ isOpenDropDownCity: false })
                                                                                    }, 500)}
                                                                                    // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                                                    onKeyDown={(e) => this.handleKeyDown(e, 1, 0)}
                                                                                />

                                                                                {/* Dropdown options - shown only if there are results */}
                                                                                {isOpenDropDownCity && tempCityList?.length > 0 && (
                                                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                        {tempCityList.map((item, index) => (
                                                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 0)}
                                                                                                // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                                                style={{
                                                                                                    whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                    backgroundColor: this.state.focusedIndexCity === index ? '#a4c2df' : 'transparent',
                                                                                                }}
                                                                                                onMouseEnter={() => this.handleHover(index, 1, 0)}
                                                                                            >
                                                                                                {item.Description}
                                                                                            </Dropdown.Item>
                                                                                        ))}
                                                                                    </Dropdown.Menu>
                                                                                )}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{cityErr}</span>}
                                                                            </div>}
                                                                            {this.showMandatoryFields(16, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2"> Email
                                                                                    {this.showMandatoryFields(16, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={email} maxLength={'50'} disabled
                                                                                    onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                                                                                    onBlur={(e) => this.verifyEmail(e)}
                                                                                    autoComplete="new-password"
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>}
                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(17, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2"> Website{this.showMandatoryFields(17, 2) && <span className="rad-star text-danger">*</span>}</label>
                                                                                <input type="text" className="form-control" value={website} maxLength={'50'}
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}

                                                                                    onChange={(e) => this.setState({ website: e.target.value, websiteErr: '' })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.websiteErr}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(21, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">Mobile No
                                                                                    {this.showMandatoryFields(21, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>

                                                                                <div className="phone-input-group">
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-code" autoComplete="off" readOnly
                                                                                        placeholder="ISD"
                                                                                        maxLength={'10'}
                                                                                        value={preMobNo}
                                                                                    />
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-no"
                                                                                        value={mobNo}
                                                                                        maxLength={'10'}
                                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ mobNo: e.target.value, mobNoErr: '' }) : null}
                                                                                    // onChange={(e) => e.target.value >= 0 &&
                                                                                    //     this.setState({ mobNo: e.target.value, mobNoErr: "" })}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{mobNoErr}</span>}
                                                                            </div>}
                                                                            {this.showMandatoryFields(22, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2"> WhatsApp Mobile No
                                                                                    {this.showMandatoryFields(22, 2) && <span className="rad-star text-danger">*</span>}
                                                                                </label>

                                                                                <div className="phone-input-group">
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-code" autoComplete="off" readOnly
                                                                                        value={preWhatsAppMobNo}
                                                                                        placeholder="ISD"
                                                                                        maxLength={'10'}
                                                                                    />
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-no"
                                                                                        value={whatsAppMobNo}
                                                                                        maxLength={'10'}
                                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                                        onWheel={(e) => e.target.blur()}

                                                                                        onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ whatsAppMobNo: e.target.value, whatsAppMobNoErr: '' }) : null}
                                                                                    // onChange={(e) => e.target.value >= 0 &&
                                                                                    //     this.setState({ whatsAppMobNo: e.target.value, whatsAppMobNoErr: "" })}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{whatsAppMobNoErr}</span>}
                                                                            </div>}
                                                                            {this.showMandatoryFields(21, 0) && this.showMandatoryFields(22, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-6">
                                                                                    <input type="checkbox" name="fav_language"
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        value={isSameAsMobNo} checked={isSameAsMobNo}
                                                                                        onClick={(e) => this.onSameAsMobNoClick(e)}
                                                                                    />
                                                                                    Same as Mobile No
                                                                                </label>
                                                                            </div>}

                                                                            {isfromAdmin && this.showMandatoryFields(37, 0) && <div className="col-xl-3 mt-3">
                                                                                <label>
                                                                                    Source
                                                                                    {/* {this.showMandatoryFields(12, 2) && <span className="text-red">*</span>} */}
                                                                                </label>
                                                                                <input type="text" className="form-control" value={Source} maxLength={'1000'}
                                                                                    onChange={(e) => this.setState({ Source: e.target.value, })}
                                                                                />
                                                                                {/* {<span className='text-danger text-start text-left d-block '>{Address3ErrModal}</span>} */}
                                                                                {/* {<span className='text-danger text-start text-left d-block '>{Address1Err}</span>} */}

                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(18, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">Telephone No{this.showMandatoryFields(18, 2) && <span className="rad-star text-danger">*</span>}</label>

                                                                                <div className="phone-input-group">
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-code" autoComplete="off"
                                                                                        value={preTelNo} placeholder="STD" maxLength={'10'}
                                                                                        onChange={(e) => this.setState({ preTelNo: e.target.value })}
                                                                                    />
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="number"
                                                                                        className="form-control phone-no"
                                                                                        value={telNo}
                                                                                        maxLength={'10'}
                                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                                                        onPaste={(e) => this.preventMinus(e)}
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        onChange={(e) => e.target.value >= 0 && this.setState({ telNo: e.target.value, telephoneErr: '' })}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.telephoneErr}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(19, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                <label className="d-flex mt-2">Telephone No 1{this.showMandatoryFields(19, 2) && <span className="rad-star text-danger">*</span>}</label>

                                                                                <div className="phone-input-group">
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="text"
                                                                                        className="form-control phone-code" autoComplete="off"
                                                                                        value={preTel1No} placeholder="STD" maxLength={'10'}
                                                                                        onChange={(e) => this.setState({ preTel1No: e.target.value })}
                                                                                    />
                                                                                    <input
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        type="number"
                                                                                        className="form-control phone-no"
                                                                                        value={tel1No}
                                                                                        maxLength={'10'}
                                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        onChange={(e) => e.target.value >= 0 && this.setState({ tel1No: e.target.value, telephone1Err: '' })}
                                                                                    />
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.telephone1Err}</span>}

                                                                            </div>}
                                                                            {this.showMandatoryFields(7, 0) && <div className="col-12 col-sm-6 col-lg-3 mt-2">
                                                                                <label htmlFor="validationCustom01">
                                                                                    GST No
                                                                                    {countryId == "91" && this.showMandatoryFields(7, 2) && (
                                                                                        <span className="text-red">*</span>
                                                                                    )}
                                                                                </label>
                                                                                <input
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    type="text"
                                                                                    maxLength={15}
                                                                                    className="form-control"
                                                                                    value={compInfoGstNo}
                                                                                    onChange={(e) =>
                                                                                        this.onGSTchange(e.target.value)
                                                                                    }
                                                                                    onInput={toInputUppercase}
                                                                                />
                                                                                {countryId == "91" && (
                                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                                        {compInfoGstNoErr}
                                                                                    </span>
                                                                                )}
                                                                            </div>}
                                                                            {this.showMandatoryFields(8, 0) && <div className="col-12 col-sm-6 col-lg-3 mt-2">
                                                                                <label htmlFor="validationCustom01">
                                                                                    PAN No
                                                                                    {countryId == "91" && this.showMandatoryFields(8, 2) && (
                                                                                        <span className="text-red">*</span>
                                                                                    )}
                                                                                </label>
                                                                                <input
                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                    type="text"
                                                                                    maxLength={10}
                                                                                    className="form-control"
                                                                                    value={compInfoPanNo}
                                                                                    onChange={(e) =>
                                                                                        this.setState({
                                                                                            compInfoPanNo: e.target.value,
                                                                                            compInfoPanNoErr: "",
                                                                                        })
                                                                                    }
                                                                                    onInput={toInputUppercase}
                                                                                />
                                                                                {countryId == "91" && (
                                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                                        {compInfoPanNoErr}
                                                                                    </span>
                                                                                )}
                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {(this.showMandatoryFields(23, 0) || this.showMandatoryFields(24, 0) || this.showMandatoryFields(25, 0) || this.showMandatoryFields(26, 0)) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h3"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h3"
                                                                > Company Profile
                                                                </button>
                                                            </h5>
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h3">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        {this.showMandatoryFields(23, 0) && <div className="col-md-12">
                                                                            <div className="row">
                                                                                <div className="col-xl-12 mb-1">
                                                                                    <label className="mt-3">Company Profile{
                                                                                        // this.showMandatoryFields(23, 2) && 
                                                                                        !this.checkCoordinatorORDelegate() &&
                                                                                        <span className="text-red">*</span>}</label>
                                                                                    <textarea disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false} type="text" className="form-control" value={companyProfile}
                                                                                        maxLength={'500'} onChange={(e) => this.setState({ companyProfile: e.target.value, companyProfileErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{companyProfileErr}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>}
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                {/* {this.showMandatoryFields(24, 0) &&
                                                                                    <div className="col-xl-4 mb-1">
                                                                                        <label className="mt-3">Website{this.showMandatoryFields(24, 2) && <span className="text-red">*</span>}</label>
                                                                                        <input type="text" className="form-control" value={companywebsite}
                                                                                            maxLength={'50'}
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            onChange={(e) => this.setState({ companywebsite: e.target.value, companyWebsiteErr: '' })}
                                                                                        />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.companyWebsiteErr}</span>}

                                                                                    </div>
                                                                                } */}
                                                                                <div className="col-xl-6 mb-2">
                                                                                    <label className="">Person's Photo{
                                                                                        // this.showMandatoryFields(23, 2) &&
                                                                                        !this.checkCoordinatorORDelegate() &&
                                                                                        <span className="text-red">*</span>}</label>
                                                                                    {(PersonPhoto ? PersonPhoto : PersonPhotoPreview) ? (
                                                                                        <div style={{ position: "relative", display: "inline-block" }}>
                                                                                            <img
                                                                                                src={
                                                                                                    (PersonPhoto?.includes("base64,") ||
                                                                                                        PersonPhotoPreview?.includes("base64,"))
                                                                                                        ? (PersonPhoto || PersonPhotoPreview)
                                                                                                        : BASE_URL?.split('/api')[0] +
                                                                                                        (PersonPhoto || PersonPhotoPreview)
                                                                                                }
                                                                                                alt="Preview"
                                                                                                style={{ width: "250px", height: "250px", objectFit: "contain", border: "1px solid #ccc" }}
                                                                                            />
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={this.clearFileInput}
                                                                                                style={{
                                                                                                    position: "absolute",
                                                                                                    top: "-8px",
                                                                                                    right: "-8px",
                                                                                                    background: "#dc3545",
                                                                                                    color: "#fff",
                                                                                                    border: "none",
                                                                                                    borderRadius: "50%",
                                                                                                    width: "26px",
                                                                                                    height: "26px",
                                                                                                    padding: 0,
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",
                                                                                                    lineHeight: 1,
                                                                                                    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)",
                                                                                                    cursor: "pointer",
                                                                                                    fontSize: "14px"
                                                                                                }}
                                                                                                title="Remove"
                                                                                            >
                                                                                                <i className="fa fa-times"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (<>
                                                                                        <input type="file" accept="image/jpeg, image/png, image/jpg"
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            className="form-control" placeholder="Upload Logo"
                                                                                            onChange={this.handleImageUpload}
                                                                                            ref={(ref) => (this.fileInputRef = ref)}
                                                                                        />
                                                                                        {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{PersonPhotoErr}</span>}
                                                                                    </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <div className="row mb-2">
                                                                                {
                                                                                    !this.checkCoordinatorORDelegate() &&
                                                                                    // this.showMandatoryFields(25, 0) &&
                                                                                    <div className="col-xl-4">
                                                                                        <label className="">Total Years the Company Is Operational{
                                                                                            // this.showMandatoryFields(25, 2) && 
                                                                                            !this.checkCoordinatorORDelegate() && <span className="text-red">*</span>}</label>
                                                                                        <input type="number" className="form-control" value={totalYears}
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            maxLength={'50'}
                                                                                            // onChange={(e) => this.setState({ totalYears: e.target.value, totalYearsErr: '' })}
                                                                                            onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ totalYears: e.target.value, totalYearsErr: '' }) : null}
                                                                                        />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{totalYearsErr}</span>}
                                                                                    </div>}
                                                                                <div className="col-xl-6">
                                                                                    <label className="">Person's Profile{
                                                                                        // this.showMandatoryFields(23, 2) &&
                                                                                        !this.checkCoordinatorORDelegate() &&
                                                                                        <
                                                                                            span className="text-red">*</span>}</label>
                                                                                    <textarea type="text" disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false} className="form-control" value={PersonProfile} maxLength={'500'}
                                                                                        onChange={(e) => this.setState({ PersonProfile: e.target.value, PersonProfileErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{PersonProfileErr}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.showMandatoryFields(26, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h4"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h4"
                                                                > Company Turn Over (in USD){
                                                                        // this.showMandatoryFields(26, 2) &&
                                                                        !this.checkCoordinatorORDelegate() &&
                                                                        <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.turnOverErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h4">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                {/* <div className="containerfluid">
                                                                <div className="row mt-2">
                                                                    <div className="p-1 title-bg d-flex">
                                                                        <p className="mb-0">
                                                                            Company Turn Over (in USD){this.showMandatoryFields(26, 2) && <span className="text-red">*</span>}
                                                                        </p>
                                                                        {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.turnOverErr}</span>}
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                                                <div className="col-12 mb-1">
                                                                                    <div className="row">
                                                                                        {
                                                                                            this.state.turnOverList?.length > 0 && this.state.turnOverList.map((data) => (
                                                                                                <div className="col-12 col-sm-auto pe-sm-5" key={data.CompanyTurnOverID}>
                                                                                                    <label className="d-flex">
                                                                                                        <input type="radio" name="turnOver" value={data.CompanyTurnOverID}
                                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                            checked={data.CompanyTurnOverID == this.state.turnOverId}
                                                                                                            // onChange={e => this.setState({ attendeeType: "Business Visitor" })}
                                                                                                            onChange={() => this.setState({ turnOverId: data.CompanyTurnOverID, turnOverErr: '' })}
                                                                                                        />
                                                                                                        {data.Description}
                                                                                                    </label>
                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.showMandatoryFields(30, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h5"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h5"
                                                                >Industry Segment{!this.checkCoordinatorORDelegate() && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.chapterErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h5">
                                                                <div className="accordion-body">
                                                                    <div className="one-section mt-2">
                                                                        {/* <div className="containerfluid">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">Industry Segment{this.showMandatoryFields(30, 2) && <span className="text-red">*</span>}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.chapterErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                        <div className="mb-0">
                                                                            <div className="row">
                                                                                <div className="asc">
                                                                                    <div className="">
                                                                                        <form className="needs-validation pb-0" noValidate="">
                                                                                            <div className="form-row">
                                                                                                {chapterList?.length > 0 && chapterList.map((data) => (
                                                                                                    <div className="col-12 col-sm-6 col-lg-3 mb-2">
                                                                                                        <section className="" key={data.IndustrySegmentID}>
                                                                                                            {/* <input type="checkbox" name="collapse"
                                                                                select={data.isSelect} checked={data.IndustrySegmentID}
                                                                                value={data.IndustrySegmentID}
                                                                            /> */}
                                                                                                            <h2 className="handle-no-icon m-0" style={{ fontSize: '14px' }}>
                                                                                                                <label style={{ color: '#212529' }}>
                                                                                                                    <input type="checkbox"
                                                                                                                        select={data.isSelect} checked={data.isSelect}
                                                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                                        value={data.IndustrySegmentID}
                                                                                                                        onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                                                    {data['Industrial Segment']}
                                                                                                                </label>
                                                                                                            </h2>
                                                                                                            {data.IndustrySegmentID == 16 && this.state.isOtherOpen && <input type="text" className="form-control" value={this.state.other}
                                                                                                                // style={{ marginRight: "50px" }}
                                                                                                                // maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                                                // onPaste={(e) => this.handlePaste(e)}
                                                                                                                // onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                                                                disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                                onChange={(e) =>
                                                                                                                    this.setState({ other: e.target.value, })}
                                                                                                            />}
                                                                                                        </section>
                                                                                                    </div>
                                                                                                ))
                                                                                                }
                                                                                            </div>
                                                                                        </form>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.showMandatoryFields(31, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h6"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h6"
                                                                >Purpose of Visit{
                                                                        // this.showMandatoryFields(31, 2) && 
                                                                        <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h6">
                                                                <div className="accordion-body">
                                                                    <div className="one-section mt-2">
                                                                        {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Purpose of Visit{this.showMandatoryFields(31, 2) && <span className="text-red">*</span>}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                        <div className="col-12 mb-1">
                                                                            <div className="row mt-2">
                                                                                {
                                                                                    visitPurposeList?.length > 0 && visitPurposeList.map((data) => (
                                                                                        <div className="col-12 col-sm-6 col-lg-3 mb-2" key={data.PurposeofVisitID}>
                                                                                            <label className="d-flex">
                                                                                                <input type="checkbox" name="fav_language"
                                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                    select={data.isSelect} checked={data.isSelect}
                                                                                                    value={data.PurposeofVisitID}
                                                                                                    onChange={(e) => this.onSelectPurpose(e)}
                                                                                                />
                                                                                                {data.PurposeofVisitName}
                                                                                            </label>
                                                                                            {
                                                                                                data.PurposeofVisitID == 10 && data.isSelect &&
                                                                                                <input
                                                                                                    className="form-control"
                                                                                                    maxLength={'100'}
                                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                    value={data.OtherDetails}
                                                                                                    onChange={(e) => this.otherDetailsChange(e)}
                                                                                                >
                                                                                                </input>
                                                                                            }
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.showMandatoryFields(32, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h7"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h7"
                                                                >Product{!this.checkCoordinatorORDelegate() && <span className="text-red">*</span>}
                                                                    {/* {this.showMandatoryFields(32, 2) && <span className="text-red">*</span>} */}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h7">
                                                                <div className="accordion-body px-2">
                                                                    <div className="one-section">
                                                                        {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Product{this.showMandatoryFields(32, 2) && <span className="text-red">*</span>}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                        <div className="col-xl-12 mb-4 px-0">
                                                                            <div className="row mt-2">
                                                                                <div class="accordion" id="accordionExample">
                                                                                    {
                                                                                        level2?.length > 0 && level2.map(level2Data => (
                                                                                            <>
                                                                                                {
                                                                                                    // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                                                    <div class="accordion-item">
                                                                                                        <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                                            <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                                                type="button" data-bs-toggle="collapse"
                                                                                                                data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                                                aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                                                {/* // checkbox for level2 */}
                                                                                                                {
                                                                                                                    level2Data.IsCheckbox &&
                                                                                                                    <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                                        checked={level2Data.isSelect}
                                                                                                                        onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                                                }
                                                                                                                {formatChapterName(level2Data.ChapterName)} </button>
                                                                                                        </h2>
                                                                                                        {this.recordTwo(level2Data, level3, level4)}
                                                                                                    </div>
                                                                                                }

                                                                                            </>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/* Same left / right edges as the product list above */}
                                                                        <div className="">
                                                                            <p className="mb-0" style={{ fontSize: 15 }}>
                                                                                <strong>  Selected Product</strong>
                                                                            </p>
                                                                        </div>
                                                                        <div>
                                                                            {
                                                                                filerArray?.length > 0 ? <ul className="selected-products-list">{filerArray.map((data) => (
                                                                                    <li>
                                                                                        {formatChapterName(data.ChapterName)}
                                                                                    </li>
                                                                                ))}</ul> :
                                                                                    <p>
                                                                                        {"No Results"}
                                                                                    </p>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {isB2bMeetingShow && this.showMandatoryFields(33, 0) && <>
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button" data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h8"
                                                                    aria-expanded="true" aria-controls="collapse_l1_h8"
                                                                > B2B meetings {isInterestTwo && this.showMandatoryFields(33, 2) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.b2bErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h8">
                                                                <div className="accordion-body px-2">
                                                                    <div className="one-section">
                                                                        <div className="col-md-12 px-0">
                                                                            <div className="row">
                                                                                <div className="col-sm-12 mt-2 mb-2" >
                                                                                    <label className="d-flex">
                                                                                        <input type="checkbox" name="fav_language"
                                                                                            select={isInterestTwo} checked={isInterestTwo}
                                                                                            disabled={sessionStorage.getItem("RoleIDSS") == 15 ? true : (dueDate != '' && dueDate != null ?
                                                                                                new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0)
                                                                                                : false)}
                                                                                            onChange={(e) => this.onSelectInterest(e)}
                                                                                        />
                                                                                        Select your B2B meeting schedule
                                                                                    </label>
                                                                                    {isInterestTwo &&
                                                                                        <>
                                                                                            <div className="col-md-12 px-0">
                                                                                                <div className="table-responsive" >
                                                                                                    <table className="table border table-bordered mb-0 mt-1" >
                                                                                                        <thead>
                                                                                                            <tr>
                                                                                                                <th className="text-center" style={{ width: '150px' }}>Date</th>
                                                                                                                <th className="text-center" style={{ width: '200px' }}>Location</th>
                                                                                                                <th className="text-center">TimeSlots</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            {B2bMeetingList?.length > 0 && B2bMeetingList.map((data) => (
                                                                                                                data.isShow && <tr>
                                                                                                                    {data.rowSpan != 0 ? <td rowSpan={data.rowSpan} className="text-center" >
                                                                                                                        {moment(data.B2BDate).format('DD MMM YYYY')}
                                                                                                                        <br />
                                                                                                                        <small>{moment(data.B2BDate).format('dddd')}</small>
                                                                                                                    </td> : <></>}
                                                                                                                    <td className="text-center" >{data.B2BLocation}</td>
                                                                                                                    <td>
                                                                                                                        <div className="d-flex flex-wrap gap-2 m-2">
                                                                                                                            {data.timeSlotList?.length > 0 && data.timeSlotList.map((item) => (
                                                                                                                                <div>
                                                                                                                                    <ToggleButton
                                                                                                                                        style={{ whiteSpace: 'nowrap' }}
                                                                                                                                        className={`py-2 px-3 rounded-5 ${item.IsBooked && 'text-white'} no-hover-toggle  `}
                                                                                                                                        id={item.B2BTimeSlotID}
                                                                                                                                        type="checkbox"
                                                                                                                                        variant={!item.IsBooked ? "outline-primary" : "outline-secondary"}
                                                                                                                                        disabled={sessionStorage.getItem("RoleIDSS") == 15 ? true : item.IsBooked}
                                                                                                                                        // disabled
                                                                                                                                        checked={item.isSelect || item.IsBooked}
                                                                                                                                        value={item.B2BTimeSlotID}
                                                                                                                                        onClick={() => this.onSelect(item.B2BTimeSlotID)}
                                                                                                                                    >{item.timeslot}
                                                                                                                                    </ToggleButton>
                                                                                                                                </div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            ))
                                                                                                            }
                                                                                                        </tbody>
                                                                                                    </table>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}
                                                {(this.showMandatoryFields(34, 0) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 0))) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h9"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h9"
                                                                > Date of Visit Single Day Pass / All Day Pass{" "} {((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2))) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h9">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        {/* <div className="containerfluid">
                                                                            <div className="row mt-2">
                                                                                <div className="col-md-12">
                                                                                    <div className="p-1 title-bg d-flex">
                                                                                        <p className="mb-0">
                                                                                            Date of Visit Single Day Pass / All Day Pass{" "}
                                                                                            {((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2))) && <span className="text-red">*</span>}
                                                                                        </p>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div> */}
                                                                        <div className="col-12 mb-2">
                                                                            <div className="row">
                                                                                {
                                                                                    daysList?.length > 0 && daysList.map((data) => (
                                                                                        <div className="col-6 col-sm-4 col-lg-2" key={data.Code}>
                                                                                            <label className="d-flex">
                                                                                                <input type="checkbox" select={data.isSelect}
                                                                                                    checked={data.isSelect} value={data.Code}
                                                                                                    disabled
                                                                                                    onChange={(e) => this.onSelectDates(e)}
                                                                                                />
                                                                                                {data.VisitDate}
                                                                                            </label>
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {!(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && this.showMandatoryFields(35, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h10"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h10"
                                                                >Visa Application {needVisaAssistance && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.visaErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h10">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        {/* <div className="containerfluid">
                                                                            <div className="row mt-2">
                                                                                <div className="col-md-12">
                                                                                    <div className="p-1 title-bg d-flex">
                                                                                        <p className="mb-0">
                                                                                            Visa Application {needVisaAssistance && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                                                                        </p>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.visaErr}</span>}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div> */}

                                                                        <div className="col-sm-12 ">
                                                                            <div className="row mt-2">
                                                                                <label className="d-flex">
                                                                                    <input type="checkbox" name="fav_language"
                                                                                        disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                        select={needVisaAssistance} checked={needVisaAssistance}
                                                                                        onChange={() => this.setState({
                                                                                            needVisaAssistance: !needVisaAssistance,
                                                                                            applicantMobNo: applicantMobNo != '' && applicantMobNo != null ? applicantMobNo : this.state.mobNo,
                                                                                            applicantEmail: applicantEmail != '' && applicantEmail != null ? applicantEmail : this.state.email,
                                                                                            preApplicantMobNo: preApplicantMobNo != '' && preApplicantMobNo != null ? preApplicantMobNo : this.state.preMobNo,
                                                                                            visaErr: '',
                                                                                            isVisaUpdated: false
                                                                                        })}
                                                                                    />
                                                                                    Do you need Visa Assistance?
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            needVisaAssistance &&
                                                                            <div
                                                                                className="col-md-12 mb-2"
                                                                                id="divMsg"
                                                                            >
                                                                                <div className="row">
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">
                                                                                            Name as per Passport<span className="text-red">*</span>
                                                                                        </label>
                                                                                        <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ passName: e.target.value, passNameErr: '', isVisaUpdated: true })}
                                                                                        // onChange={(e) => /^[A-Za-z\s]+$/.test(e.target.value) ? this.setState({ passName: e.target.value, passNameErr: "" }) : null}
                                                                                        />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">
                                                                                            Applicant mobile number<span className="text-red">*</span>
                                                                                        </label>

                                                                                        <div className="phone-input-group">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control phone-code mt-2" autoComplete="off" placeholder="ISD" readOnly
                                                                                                disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                // placeholder="ISD"
                                                                                                value={preApplicantMobNo}
                                                                                                maxLength={'10'}
                                                                                            />
                                                                                            <input type="text" className="form-control phone-no" value={applicantMobNo}
                                                                                                disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                                onPaste={(e) => this.handlePaste(e)}
                                                                                                onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: '', isVisaUpdated: true }) : null}
                                                                                            // onChange={(e) => e.target.value >= 0 &&
                                                                                            //     this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "" })}
                                                                                            />
                                                                                        </div>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">
                                                                                            Applicant email id<span className="text-red">*</span>
                                                                                        </label>
                                                                                        <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "", isVisaUpdated: true })}
                                                                                        // onBlur={(e) => this.verifyEmail(e, 2)}
                                                                                        />

                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">Passport No
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                                            disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                            onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "", isVisaUpdated: true })}
                                                                                        />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">Passport issue Date
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <DatePicker selected={passDate}
                                                                                            onChange={(date) =>
                                                                                                this.setState({
                                                                                                    passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                    passDateErr: "", isVisaUpdated: true
                                                                                                })}
                                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                            peekNextMonth
                                                                                            showMonthDropdown
                                                                                            showYearDropdown
                                                                                            maxDate={passExipryDate}
                                                                                            dropdownMode="select"
                                                                                            placeholderText="Passport Issued Date"
                                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                                            popperClassName="example-datepicker-class" />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-3">Passport Expiry Date
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <DatePicker selected={passExipryDate}
                                                                                            onChange={(date) =>
                                                                                                this.setState({
                                                                                                    passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                    passExipryDateErr: "", isVisaUpdated: true
                                                                                                })}
                                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                            peekNextMonth
                                                                                            showMonthDropdown
                                                                                            showYearDropdown
                                                                                            minDate={passDate}
                                                                                            dropdownMode="select"
                                                                                            placeholderText="Passport Expiry Date"
                                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                                            popperClassName="example-datepicker-class" />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                                                    </div>
                                                                                    <div className="col-xl-3">
                                                                                        <div className="d-flex">
                                                                                            <label className="mt-3 w-auto" >
                                                                                                Passport issuing Country
                                                                                                <span className="text-red">*</span>

                                                                                            </label>
                                                                                        </div>
                                                                                        <select className="form-control" value={passCountry}
                                                                                            onChange={(e) => this.onCountrySelect(e, 2)}
                                                                                        >
                                                                                            <option>Select Your Country</option>
                                                                                            {
                                                                                                countryList?.length > 0 && countryList.map((data) => (
                                                                                                    <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                                ))
                                                                                            }
                                                                                        </select>
                                                                                        {<span className='text-danger text-start text-left d-block'>{passCountryErr}</span>}

                                                                                    </div>
                                                                                    {/* <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={passCountry}
                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                        />
                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{ }</span>}
                                                    </div> */}
                                                                                    {!(isPassportFilePresent) && !isVisaApplied &&
                                                                                        < div className="col-xl-12">
                                                                                            <label className="mt-3">
                                                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                                                <span className="text-red">*</span>
                                                                                            </label>
                                                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                                                <input type="file" id="passportFile" name="filename"
                                                                                                    disabled={dueDate != '' && dueDate != null ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                                    accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                                                    onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                                                />
                                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportFileErr}</span>}
                                                                                                {
                                                                                                    passportFile != "" &&
                                                                                                    <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                                                }
                                                                                            </form>
                                                                                        </div>
                                                                                    }
                                                                                    {
                                                                                        isVisaApplied && passportFile != "" && passportFile != null &&
                                                                                        <div className="col-xl-12">
                                                                                            <label className="mt-3">
                                                                                                Passport Front Page File
                                                                                                <span className="text-red">*</span>
                                                                                            </label>
                                                                                            <div style={{
                                                                                                border: '1px solid #ccc',
                                                                                                padding: '10px',
                                                                                                // display: 'inline-flex',
                                                                                                alignItems: 'center',
                                                                                                marginTop: '10px',
                                                                                                // marginLeft: '12px',
                                                                                                maxWidth: '300px'
                                                                                            }}>
                                                                                                <span style={{ marginRight: '10px' }}
                                                                                                >{passPortFileName}</span>
                                                                                                <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1, 1)}></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.showMandatoryFields(36, 0) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h11"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h11"
                                                                > Seminar{this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.SeminarErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h11">
                                                                <div className="accordion-body px-2 pt-2">
                                                                    <div className="one-section">
                                                                        {/* <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="containerfluid">
                                                                    <div className="row mt-2">

                                                                        <div className="p-1 title-bg d-flex">
                                                                            <p className="mb-0">
                                                                                Seminar{this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                                                            </p>
                                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.SeminarErr}</span>}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div> */}
                                                                        <div className="col-md-12 px-0">
                                                                            <div className="table-responsive" >

                                                                                <table className="table border text-nowrap text-md-nowrap table-bordered mt-0 ">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                                            <th style={{ width: '80px' }} className="text-center">Register</th>
                                                                                            <th style={{ width: '300px' }}>Date & Time</th>
                                                                                            <th style={{ minWidth: '250px' }}>Session Name</th>
                                                                                            {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                                            {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            seminarInterestList.length > 0 && seminarInterestList.map((data) => (
                                                                                                <>
                                                                                                    {/* {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                            <td style={{ borderRight: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                        </tr>} */}
                                                                                                    {data.IsVisitor && <tr key={Math.random()}>
                                                                                                        {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                                            <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                                                            : <></>}
                                                                                                        <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                                            {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                                                (data.SeminarTypeID == 2 ?
                                                                                                                    <a
                                                                                                                        style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                                                        className="btn btn-aqua me-2"
                                                                                                                        // type="submit"
                                                                                                                        onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                    >
                                                                                                                        {data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                                                    </a>
                                                                                                                    : data.SeminarTypeID == 3 ?

                                                                                                                        <input
                                                                                                                            // style={{ marginTop: '12px' }}
                                                                                                                            type="checkbox"
                                                                                                                            checked={data.isSelect}
                                                                                                                            onChange={(e) =>
                                                                                                                                this.setState({
                                                                                                                                    ChargesPop: !data.isSelect ? true : false,
                                                                                                                                    seminarCharges: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                                                    seminarCGST: sessionStorage.getItem("countryId") == 91 ? data.INRCGST : 0,
                                                                                                                                    seminarSGST: sessionStorage.getItem("countryId") == 91 ? data.INRSGST : 0,
                                                                                                                                    seminarIGST: sessionStorage.getItem("countryId") == 91 ? data.INRIGST : data.USDIGST,
                                                                                                                                    TotalPayable: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                                                }, () => {
                                                                                                                                    this.onCheckedSeminar(e, data.SeminarID)
                                                                                                                                })
                                                                                                                            }
                                                                                                                        />
                                                                                                                        :
                                                                                                                        <input type="checkbox"
                                                                                                                            value={data.isSelect}
                                                                                                                            checked={data.isSelect}
                                                                                                                            onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                        />)
                                                                                                            }
                                                                                                        </td>
                                                                                                        <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                                                        <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}{data.SeminarDetailsHtmlRef ? <>&nbsp;<span style={{ cursor: 'pointer' }} className="text-primary" onClick={() => {
                                                                                                            this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                        }}>Click Here</span> to view more details.</> : ''}</td>
                                                                                                        {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                                        {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                                        {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                                        {/* <td className="text-center">
                                                                                                                {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                    <span onClick={() => {
                                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                    }}>
                                                                                                                        <i class="bi bi-info-circle"></i>
                                                                                                                    </span> : <></>}
                                                                                                            </td> */}

                                                                                                    </tr>}
                                                                                                </>
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                                <div />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {/* {(this.showMandatoryFields(27, 0) || this.showMandatoryFields(28, 0)) &&
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h12"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h12"
                                                                >Arrival and Departure<span className="text-red">*</span>
                                                                </button>
                                                            </h5>
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h12">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                {this.showMandatoryFields(27, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                    <label>Arrival Date{this.showMandatoryFields(27, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                                    <DatePicker
                                                                                        style={{ zIndex: '99999' }}
                                                                                        selected={arrivalDate}
                                                                                        dateFormat={"dd/MM/yyyy"}
                                                                                        className="form-control"
                                                                                        onChange={(date) => this.setState({ arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), arrivalDateErr: '' })}
                                                                                        peekNextMonth
                                                                                        // maxDate={toDate}
                                                                                        minDate={new Date()}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        placeholderText="Arrival Date"
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(28, 0) && <div className="col-12 col-sm-6 col-lg-3">
                                                                                    <label>Departure Date{this.showMandatoryFields(28, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                                    <DatePicker
                                                                                        style={{ zIndex: '99999' }}
                                                                                        selected={departureDate}
                                                                                        dateFormat={"dd/MM/yyyy"}
                                                                                        className="form-control"
                                                                                        onChange={(date) => this.setState({ departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), departureDateErr: '' })}
                                                                                        peekNextMonth
                                                                                        // maxDate={toDate}
                                                                                        minDate={new Date()}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        placeholderText="Departure Date"
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>}
                                                                                </div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                } */}
                                                {/* <div className="one-section mt-2">
                                                    <div className="col-xl-6 mt-2">
                                                        <p className="fw-bold m-0">Note:</p>
                                                        {this.state.note?.length > 0 && this.state.note.map((item, i) => (
                                                            <p className="ms-2">{i + 1}	{item}</p>
                                                        ))}
                                                        <label className="d-flex" style={{ marginLeft: '3rem' }} ></label>
                                                    </div>
                                                </div> */}
                                                {this.showMandatoryFields(29, 0) && <div className="one-section mt-2">
                                                    <div className="col-xl-12 px-0">
                                                        <div className="form-row my-2 mx-0">
                                                            <div >
                                                                <label className="d-flex" >
                                                                    <input type="checkbox" style={{ height: 20 }}
                                                                        value={agreeTerms} checked={agreeTerms}
                                                                        disabled
                                                                        onClick={() => this.setState({ agreeTerms: !agreeTerms })}
                                                                    />I agree all the rules & regulations of delegation process & Exhibition Guidelines of India ITME Society
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {AccountTypeID != 10 && AccountTypeID != '' && AccountTypeID != null && (
                                                    <div className="mt-4" style={{ marginRight: 16 }}>
                                                        <h6 className="mb-1 mt-2 fw-semibold mb-3"><i className="fa fa-list-alt me-2"></i>Program</h6>
                                                        <div className="table-responsive rounded bg-white">
                                                            <table className="table table-bordered table-hover align-middle mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className="text-center" style={{ width: '50px' }}>
                                                                            <input type="checkbox" className=" mt-0"
                                                                                disabled={sessionStorage.getItem('RoleIDSS') == 15}

                                                                            // checked={this.checkselectallprogram()}
                                                                            // onChange={() => {
                                                                            //     for (var i = 0; i < programList.length; i++) {
                                                                            //         programList[i].isSelect = true
                                                                            //         for (var j = 0; j < programList[i].category.length; j++) {
                                                                            //             programList[i].category[j].isSelect = true
                                                                            //         }
                                                                            //     }
                                                                            //     this.setState({ programList: programList })
                                                                            // }}
                                                                            // checked={this.state.master_all || false}
                                                                            // onChange={(e) => {
                                                                            //     const checked = e.target.checked;
                                                                            //     const newState = {
                                                                            //         master_all: checked,
                                                                            //         p1_all: checked,
                                                                            //         p2_all: checked, p2_0: checked, p2_1: checked, p2_2: checked,
                                                                            //         p3_all: checked
                                                                            //     };
                                                                            //     ['p3_0_cat_0', 'p3_0_cat_1', 'p3_0_cat_2', 'p3_0_cat_3'].forEach(k => newState[k] = checked);
                                                                            //     this.setState(newState);
                                                                            // }}
                                                                            />
                                                                        </th>
                                                                        <th style={{ width: '220px' }}>Program Name </th>
                                                                        <th style={{ width: '220px' }}>Date & time</th>
                                                                        <th>Category</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Location</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Invitation Card</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(sessionStorage.getItem('RoleIDSS') == 15 ? showProgramTable : true) && programList.length > 0 && programList.map(item => (
                                                                        (sessionStorage.getItem('RoleIDSS') == 15 ? item.isSelect : true) && <tr>
                                                                            {item.toShow && <>
                                                                                <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0">
                                                                                    <input type="checkbox" className=" mt-0"
                                                                                        disabled={sessionStorage.getItem('RoleIDSS') == 15}
                                                                                        checked={this.checkSelectedProgram(item.ExhProgramID)}
                                                                                        onChange={(e) => this.selectProgram(1, item.ExhProgramID)} />
                                                                                </td>
                                                                                <td rowSpan={item.rowspan} className="fw-semibold align-middle bg-white border-bottom-0 text-dark">{item.ProgramName}</td>
                                                                            </>}
                                                                            <td>
                                                                                <div className="d-flex align-items-center">
                                                                                    {
                                                                                        item.rowspan > 1 &&
                                                                                        <input type="checkbox" className=" me-2 mt-0"
                                                                                            checked={item.isSelect}
                                                                                            disabled={sessionStorage.getItem('RoleIDSS') == 15}
                                                                                            onChange={(e) => this.selectProgram(2, item.ExhProgramDateID)}
                                                                                        //  onChange={(e) => this.setState({ [`p2_${i}`]: e.target.checked, p2_all: false, master_all: false })}
                                                                                        />}
                                                                                    <span style={{ fontSize: '14px' }}>{item.Date}</span>
                                                                                    {<span style={{ fontSize: '14px' }} className="ms-2 text-muted"><i className="fa fa-clock-o me-1"></i>{item.StartTime} - {item.EndTime}</span>}
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex flex-wrap gap-3">
                                                                                    {item.catogary.length > 0 ?
                                                                                        <div className="d-flex flex-row align-items-center gap-3 flex-nowrap">{
                                                                                            item.catogary.map(element => (
                                                                                                <label className="mb-0 d-flex flex-row align-items-center" style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>
                                                                                                    {item.catogary.length > 1 && <input type="checkbox" className="me-2 mt-0" style={{ width: '16px', height: '16px' }}
                                                                                                        checked={element.isSelect}
                                                                                                        disabled={sessionStorage.getItem('RoleIDSS') == 15}
                                                                                                        onChange={(e) => this.selectProgram(3, element.ExhProgramCategoryID)}
                                                                                                    // onChange={(e) => this.setState({ [`${d.rowKey}_cat_${cIdx}`]: e.target.checked, p3_all: false, master_all: false })}
                                                                                                    />}
                                                                                                    <span className="text-dark">{element.CategoryName}</span>
                                                                                                </label>
                                                                                            ))
                                                                                        }</div> :
                                                                                        <div className="d-flex flex-wrap gap-3">
                                                                                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>-</span>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </td>
                                                                            {item.toShow && (
                                                                                <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">{item.Location}</td>
                                                                            )}
                                                                            {/* Follow-on date rows are covered by the rowSpan, so they get no cell here */}
                                                                            {item.toShow && (
                                                                                <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">
                                                                                    {item.DocumentPath != '' &&
                                                                                        <a
                                                                                            href={item.DocumentPath}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            <span style={{ marginRight: '10px' }}
                                                                                            >{item.DocumentName}</span>
                                                                                        </a>}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                )}
                                                {!isLoading ?
                                                    <div className="main-container mx-0 px-0" style={{ height: 64 }}>
                                                        {/* Outer div keeps 64px free at the end of the form; the bar itself is fixed to the bottom */}
                                                        <div className="sticky-actions fixed-actions d-flex">
                                                            <button className="btn btn-aqua rounded-3 d-block"
                                                                style={{ marginRight: 10 }} onClick={(e) => this.handleSubmit(e)}>
                                                                Update
                                                            </button>
                                                            {sessionStorage.getItem("RoleIDSS") != 15 &&
                                                                <button
                                                                    className="btn btn-gray px-2"
                                                                    onClick={(e) => this.cancle()}
                                                                >
                                                                    Back
                                                                </button>}
                                                        </div>
                                                    </div> : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header p-2">
                                    <h5 class="modal-title modal_title_text text-danger">Confirm Delete</h5>
                                    <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="pop_label">Do you really want to delete this Document?</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button>
                                        <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div >
            </>
        )
    }
}
export default withRouter(connect(null, {
    fill_action, combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, payment_action, getDelegatePreviewDetails_action, getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action, getExhNoteDetails_action, getDelegateCombineDetails_action, delegateRegistrationCombineSubmit_action, getDelegateFirldList_action,
    deleteVisaDoc_action, getVisitorRegistrationCredentials_action, getDrawerDetails_action, getCoordinatorVisitor_action, getExhibitionProgramMaster_action, verifyVisitorEmail_action,
})(DelegateForm))

